const defaultLang = "FR";

const translate = (id, languageCode) => {
    languageCode = languageCode ? languageCode : "FR";
    var dictEntry = dictionary.find(x => x.id === id);
    if (!dictEntry) {
        return `[404]${id}`
    }
    if (!Object.hasOwn(dictEntry, languageCode)) {
        languageCode = defaultLang;
    }
    if (isEmptyOrSpaces(dictEntry[languageCode])) {
        return `[${dictEntry.id}]`
    }
    return dictEntry[languageCode];
}

function isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
}

const dictionary = [
    {
        "id": "homeHeroTitle",
        "FR": "AXA HomeCare",
        "NL": "AXA HomeCare"
    },
    {
        "id": "homeHeroListItem1",
        "FR": "Des professionnels triés sur le volet ",
        "NL": "Specialisten met zorg geselecteerd"
    },
    {
        "id": "homeHeroListItem2",
        "FR": "Une intervention rapide",
        "NL": "Snelle interventie"
    },
    {
        "id": "homeHeroListItem3",
        "FR": "Un très bon rapport qualité-prix",
        "NL": "Uitstekende prijs-kwaliteit verhouding"
    },
    {
        "id": "homeHappyToHelpTitle",
        "FR": "Nous vous accompagnons",
        "NL": "Wij helpen je graag verder "
    },
    {
        "id": "homeHappyToHelpText",
        "FR": "Que vous ayez besoin d’une réparation urgente ou de petits travaux de rénovation, les professionnels que nous vous avons sélectionnés vous délivrent des prestations sur mesure et conformes aux dernières normes en vigueur.",
        "NL": "Of je nu behoefte hebt aan een dringende reparatie of kleine renovatiewerkzaamheden, de specialisten die we voor je hebben geselecteerd, leveren maatwerk conform de laatste geldende normen."
    },
    {
        "id": "homeHowItWorksTitle",
        "FR": "Comment ça marche?",
        "NL": "Hoe werkt het?"
    },
    {
        "id": "homeHowItWorksTextLine1",
        "FR": "Pas toujours évident de trouver rapidement la perle rare, et ce à prix raisonnable, surtout quand on est confronté à une panne ou autre petit pépin ! ",
        "NL": "Het is niet altijd gemakkelijk om snel de juiste vakman te vinden tegen een redelijke prijs, vooral wanneer je te maken hebt met een storing of een ander klein probleem! "
    },
    {
        "id": "homeHowItWorksTextLine2",
        "FR": "AXA a sélectionné pour vous les meilleurs corps de métier de chaque région.",
        "NL": "AXA heeft voor jou de beste vakmensen in elke regio geselecteerd."
    },
    {
        "id": "homeHowItWorksStep1Title",
        "FR": "Choisissez le service dont vous avez besoin",
        "NL": "Kies de dienst die je nodig hebt"
    },
    {
        "id": "homeHowItWorksStep1Text",
        "FR": "Sélectionnez parmi les services proposés celui qui pourra résoudre votre problème ou améliorer votre situation.",
        "NL": "Selecteer uit de aangeboden diensten degene die jouw probleem kan oplossen of jouw situatie kan verbeteren"
    },
    {
        "id": "homeHowItWorksStep2Title",
        "FR": "Décrivez votre projet",
        "NL": "Beschrijf jouw project"
    },
    {
        "id": "homeHowItWorksStep2Text",
        "FR": "Donnez des précisions sur la réparation ou rénovation pour laquelle vous cherchez un corps de métier.",
        "NL": "Geef details over de reparatie of renovatie waarvoor je een vakman zoekt."
    },
    {
        "id": "homeHowItWorksStep3Title",
        "FR": "Vous êtes contactés dans un delai de deux jours ouvrables",
        "NL": "Je wordt binnen de twee werkdagen gecontacteerd"
    },
    {
        "id": "homeHowItWorksStep3Text",
        "FR": "Le professionnel le plus indiqué vous contactera dans un délai d'un à deux jours ouvrables afin de pouvoir établir un devis.",
        "NL": "De meest geschikt specialist zal binnen de één tot twee werkdagen contact met je opnemen om een offerte op te stellen."
    },
    {
        "id": "homeHowItWorksStep4Title",
        "FR": "Fixez un rendez-vous",
        "NL": "Maak een afspraak"
    },
    {
        "id": "homeHowItWorksStep4Text",
        "FR": "Convenez du meilleur moment pour effectuer les travaux avec l’homme de métier qui a pris contact avec vous.",
        "NL": "Bepaal samen met de vakman die je gecontacteerd heeft, het beste tijdstip voor de werkzaamheden."
    },
    {
        "id": "homeFAQTitle",
        "FR": "Des questions ?",
        "NL": "Heb je vragen?"
    },
    {
        "id": "homeQ1Title",
        "FR": "Que dois-je faire si je ne retrouve pas sur cette plateforme les travaux à effectuer ?",
        "NL": "Wat moet ik doen als de werkzaamheden die ik nodig heb, niet beschikbaar zijn op dit platform?"
    },
    {
        "id": "homeQ1Text",
        "FR": "Dans ce cas, écrivez-nous sans attendre à l’adresse e-mail suivante : network.bnl@axa-assistance.com. Nous nous mettrons immédiatement à la recherche d’un spécialiste adéquat et nous vous ferons savoir dans les 24h si nous l’avons trouvé. ",
        "NL": "In dat geval kan je ons direct een e-mail sturen naar het volgende adres: network.bnl@axa-assistance.com. We gaan dan direct op zoek naar een geschikte specialist en laten je binnen 24 uur weten of we die hebben gevonden."
    },
    {
        "id": "homeQ2Title",
        "FR": "Sur quelle base les hommes de métier proposés sont-ils sélectionnés ?",
        "NL": "Op welke basis worden de aangeboden vakmensen geselecteerd? "
    },
    {
        "id": "homeQ2Text",
        "FR": "C’est en nous appuyant sur notre longue expérience que nous sommes parvenus à sélectionner un certain nombre de spécialistes reconnus pour leur fiabilité et leurs qualifications. Nous pouvons ainsi vous recommander l’homme de métier le plus indiqué pour effectuer avec soin et professionnalisme les travaux que vous demandez.",
        "NL": "Met onze jarenlange ervaring hebben we een aantal betrouwbare en gekwalificeerde specialisten kunnen selecteren. Op deze manier kunnen we je de meest geschikte vakman aanbevelen om zorgvuldig en professioneel de gevraagde werkzaamheden uit te voeren."
    },
    {
        "id": "homeQ3Title",
        "FR": "Comment procède-t-on pour la facturation ?",
        "NL": "Hoe verloopt de facturatie? "
    },
    {
        "id": "homeQ3Text",
        "FR": "Une fois les travaux réalisés, vous recevrez la facture par email. Vous devez ensuite le payer directement au prestataire de services.",
        "NL": "Nadat de werkzaamheden zijn uitgevoerd, krijg je per e-mail de factuur doorgestuurd. U dient deze dan rechtstreeks aan de dienstverlener te betalen."
    },
    {
        "id": "homeQ4Title",
        "FR": "Comment puis-je entrer en contact avec le fournisseur qui m’est proposé ?",
        "NL": "Hoe kan ik contact opnemen met de voorgestelde dienstverlener?"
    },
    {
        "id": "homeQ4Text",
        "FR": "Une fois qu’il a été informé de votre demande par nos services, c’est l’homme de métier lui-même qui vous téléphone ou vous envoie un e-mail afin de préciser votre demande, vous adresser un devis et ensuite convenir d’un rendez-vous.",
        "NL": "Zodra de dienstverlener door onze diensten op de hoogte is gebracht van je aanvraag, neemt de vakman via telefoon of e-mail zelf contact met je op om je verzoek te verduidelijken, een offerte te sturen en vervolgens een afspraak te maken."
    },
    {
        "id": "homeQ5Title",
        "FR": "Dans quel délai les travaux peuvent-ils commencer ?",
        "NL": "Binnen welke termijn kunnen de werkzaamheden beginnen? "
    },
    {
        "id": "homeQ5Text",
        "FR": "Tout dépend bien sûr de la disponibilité de l’homme de métier ainsi que de la vôtre. Mais vous aurez l’opportunité de discuter de l’urgence ou non de vos travaux directement avec le spécialiste au moment où il prendra contact avec vous.",
        "NL": "Dat hangt natuurlijk af van de beschikbaarheid van de vakman en jezelf. Maar je krijgt de gelegenheid om de urgentie van je werkzaamheden rechtstreeks met de specialist te bespreken wanneer hij contact met je opneemt."
    },

    //Service Page Static Text and Headers
    {
        "id": "serviceChooseYourServiceTitle",
        "FR": "Choisissez votre service",
        "NL": "Kies jouw dienst"
    },
    {
        "id": "serviceBackToOverview",
        "FR": "retour à l'aperçu",
        "NL": "Terug naar overzicht"
    },

    {
        "id": "newProjectBack",
        "FR": "RETOUR",
        "NL": "TERUG"
    },
    {
        "id": "newProjectStepService",
        "FR": "Sélectionner un service",
        "NL": "Selecteer een dienst"
    },
    {
        "id": "newProjectStepExpert",
        "FR": "Trouver un professionnel",
        "NL": "Vind een specialist"
    },
    {
        "id": "newProjectStepDetails",
        "FR": "Détails de l’intervention",
        "NL": "Details van de interventie"
    },
    {
        "id": "newProjectStepIformation",
        "FR": "Vos informations personnelles",
        "NL": "Je contactgegevens"
    },
    {
        "id": "newProjectStepConfirmation",
        "FR": "Confirmation",
        "NL": "Bevestiging"
    },
    {
        "id": "newProjectTitleService",
        "FR": "Service",
        "NL": "Service"
    },
    {
        "id": "newProjectTextService",
        "FR": "Décrivez ci-après ce dont vous avez besoin. De cette façon, l’homme de métier le plus adéquat dans votre région pourra vous contacter dans les 48 h.",
        "NL": "Beschrijf hieronder wat je nodig hebt. Op deze manier kan de meest geschikte vakman in jouw regio binnen 48 uur contact met je opnemen."
    },
    {
        "id": "newProjectLabelCategory",
        "FR": "Choisissez le service adéquat",
        "NL": "Kies de juiste service"
    },
    {
        "id": "newProjectLabelSubCategory",
        "FR": "Choisissez une prestation spécifique",
        "NL": "Kies een specifieke dienst"
    },
    {
        "id": "newProjectLabelService",
        "FR": "Précisez votre sélection",
        "NL": "Specificeer je selectie"
    },
    {
        "id": "newProjectLabelServiceUnderText",
        "FR": "Vous ne pouvez choisir qu’un seul service spécifique",
        "NL": "Je kunt maar één specifieke dienst selecteren."
    },
    {
        "id": "newProjectSelectMakeASelectionText",
        "FR": "Choisissez le service adéquat",
        "NL": "Kies de juiste service"
    },
    {
        "id": "newProjectTitleExpert",
        "FR": "Un professionnel tout près de chez vous",
        "NL": "Een specialist bij jou in de buurt"
    },
    {
        "id": "newProjectTextExpert",
        "FR": "Nous tenons à vous mettre en contact avec l’homme de métier le plus adéquat dans votre région. Voilà pourquoi nous voulons d’abord vérifier s’il y a un professionnel disponible tout près de chez vous. Nous examinerons ensuite ce dont vous avez besoin.",
        "NL": "We willen je graag in contact brengen met de meest geschikte vakman in je regio. Daarom willen we eerst controleren of er bij jou in de buurt een specialist beschikbaar is. Vervolgens zullen we bekijken waar je behoefte aan hebt."
    },
    {
        "id": "newProjectLabelExpertPostCode",
        "FR": "Code postal",
        "NL": "Postcode"
    },
    {
        "id": "newProjectLabelExpertUnderText",
        "FR": "Exemple : 1000",
        "NL": "Voorbeeld: 1000"
    },
    {
        "id": "newProjectExpertCheckAvailabilityButton",
        "FR": "VÉRIFIEZ LA DISPONIBILITÉ",
        "NL": "CONTROLEER DE BESCHIKBAARHEID"
    },
    {
        "id": "newProjectExpertCheckSuccessTitle",
        "FR": "On a trouvé un professionnel dans votre région.",
        "NL": "We hebben een specialist in uw regio gevonden"
    },
    {
        "id": "newProjectExpertCheckSuccessText",
        "FR": "Si vous continuez, il vous recontactera dans les deux jours ouvrables.",
        "NL": "Als je doorgaat, nemen zij binnen de twee werkdagen contact met u op "
    },
    {
        "id": "newProjectExpertCheckWarningTitle",
        "FR": "Malheureusement, nous ne pouvons pas trouver de spécialiste dans votre région pour le moment, mais nous nous efforçons de vous en trouver un rapidement.",
        "NL": "Op dit moment vinden wij helaas geen specialist in jouw omgeving, maar we doen ons best om er snel een voor je te vinden."
    },
    {
        "id": "newProjectExpertCheckWarningText",
        "FR": "En poursuivant votre navigation, vous nous indiquez que vous souhaitez être recontacté dans les deux jours ouvrables.",
        "NL": "Door verder te gaan, geef je aan dat je graag binnen twee werkdagen gecontacteerd wil worden."
    },
    {
        "id": "newProjectDoYouWantToContinue",
        "FR": "Voulez-vous continuer?",
        "NL": "Wens je verder te gaan?"
    },
    {
        "id": "newProjectServiceAreYouSureTitle",
        "FR": "Voulez-vous choisir un autre service?",
        "NL": "Wil je een andere dienst kiezen?"
    },
    {
        "id": "newProjectServiceAreYouSureText",
        "FR": "En choisissant un autre service, vous risquez de perdre les informations que vous avez introduites aux étapes 2 et 3. Cela signifie parfois aussi que - suivant le service que vous souhaitez - nous allons devoir effectuer une nouvelle recherche pour trouver un nouveau spécialiste adéquat en fonction de votre code postal.",
        "NL": "Door voor een andere dienst te kiezen, loop je het risico de informatie die je hebt ingevoerd in stappen 2 en 3 te verliezen. Dit betekent soms ook dat – afhankelijk van de gewenste dienst – we een nieuwe zoekopdracht moeten uitvoeren om een nieuwe geschikte specialist te vinden op basis van je postcode."
    },
    {
        "id": "newProjectServiceAreYouSureCancelButton",
        "FR": "ANNULER",
        "NL": "ANNULEREN"
    },
    {
        "id": "newProjectServiceAreYouSureApproveButton",
        "FR": "JE SUIS SÛR",
        "NL": "IK BEN ZEKER"
    },
    {
        "id": "newProjectDetailsTitle",
        "FR": "Détails de l’intervention",
        "NL": "Details van de interventie"
    },
    {
        "id": "newProjectDetailsSecondaryTitleSpecifics",
        "FR": "Spécifiquement",
        "NL": "Specifiek"
    },
    {
        "id": "newProjectDetailsSecondaryTitleDetails",
        "FR": "Donnez-nous de plus amples informations",
        "NL": "Geef ons meer informatie"
    },
    {
        "id": "newProjectDetailsLabelDetailText",
        "FR": "Description spécifique",
        "NL": "Specifieke beschrijving"
    },
    {
        "id": "newProjectDetailsLabelFile",
        "FR": "Documents ou photos supplémentaires",
        "NL": "Extra documenten of foto's "
    },
    {
        "id": "newProjectDetailsLabelOptional",
        "FR": "(optionnel)",
        "NL": "(optioneel)"
    },
    {
        "id": "newProjectDetailsFileUploadDropDescription",
        "FR": "Sélectionnez vos fichiers",
        "NL": "SELECTEER JE BESTANDEN"
    },
    {
        "id": "newProjectDetailsFileUploadOR",
        "FR": "Ou",
        "NL": "Of"
    },
    {
        "id": "newProject-checkAswerTypeDescr",
        "FR": "plusieurs réponses possibles",
        "NL": "Meerdere antwoorden mogelijk"
    },
    {
        "id": "newProject-radioAswerTypeDescr",
        "FR": "sélectionnez votre réponse",
        "NL": "Selecteer je antwoord"
    },
    {
        "id": "newProjectFileSizeAndTypeDescr",
        "FR": "Vous pouvez télécharger des fichiers de ce type de format : .jpg (max. 10 mb par document)",
        "NL": "Je kan bestanden uploaden in dit bestandsformaat: .jpg (max. 10 MB per document)"
    },
    {
        "id": "newProjectFileTableFileNameHeader",
        "FR": "Nom de fichier",
        "NL": "Bestandsnaam"
    },
    {
        "id": "newProjectFileTableDeleteHeader",
        "FR": "Action",
        "NL": "Actie"
    },
    {
        "id": "newProjectCustomerInfoHeader",
        "FR": "Vos informations personnelles",
        "NL": "Je persoonlijke informatie"
    },
    {
        "id": "newProjectCustomerInfoSecondaryTitleContact",
        "FR": "Vos coordonnées",
        "NL": "Je contactgegevens"
    },
    {
        "id": "newProjectCustomerInfoLabelAxaCustomer",
        "FR": "Êtes-vous déjà client chez AXA ?",
        "NL": "Ben je al klant bij AXA?"
    },
    {
        "id": "newProjectCustomerInfoLabelLastName",
        "FR": "Nom",
        "NL": "Naam"
    },
    {
        "id": "newProjectCustomerInfoBtnAxaCustomerYes",
        "FR": "OUI",
        "NL": "JA"
    },
    {
        "id": "newProjectCustomerInfoBtnAxaCustomerNo",
        "FR": "NON",
        "NL": "NEE"
    },
    {
        "id": "newProjectCustomerInfoLabelFirstName",
        "FR": "Prénom",
        "NL": "Voornaam"
    },
    {
        "id": "newProjectCustomerInfoLabelGsmNumber",
        "FR": "N° de GSM",
        "NL": "GSM-nummer"
    },
    {
        "id": "newProjectCustomerInfoSecondaryLabelGsmNumberExample",
        "FR": "Exemple : +32 000 00 00 00",
        "NL": "Voorbeeld: +32 000 00 00 00"
    },
    {
        "id": "newProjectCustomerInfoLabelEmail",
        "FR": "E-mail",
        "NL": "E-mail"
    },
    {
        "id": "newProjectCustomerInfoSecondaryLabelEmailExample",
        "FR": "Exemple : name@domaine.com",
        "NL": "Voorbeeld: naam@domein.com"
    },
    {
        "id": "newProjectCustomerInfoSecondaryTitleAddress",
        "FR": "Votre adresse",
        "NL": "Je adres"
    },
    {
        "id": "newProjectCustomerInfoLabelStreetAndHouse",
        "FR": "Rue et n°",
        "NL": "Straat en nummer"
    },
    {
        "id": "newProjectCustomerInfoLabelBusStation",
        "FR": "Boîte",
        "NL": "Bus"
    },
    {
        "id": "newProjectCustomerInfoLabelCity",
        "FR": "Localité",
        "NL": "Plaats"
    },
    {
        "id": "newProjectCustomerInfoLabelPostalCode",
        "FR": "Code postal",
        "NL": "Postcode"
    },
    {
        "id": "newProjectPrivacyBeforeLink",
        "FR": "j’ai bien lu et compris la ",
        "NL": "Ik heb het "
    },
    {
        "id": "newProjectPrivacyLink",
        "FR": "politique de confidentialité",
        "NL": "privacybeleid van AXA "
    },
    {
        "id": "newProjectPrivacyAfterLink",
        "FR": ".",
        "NL": " goed gelezen en begrepen."
    },
    {
        "id": "newProjectMarketingAccept",
        "FR": "AXA peut m’adresser des e-mails à vocation marketing (optionnel)",
        "NL": "AXA kan mij e-mails met marketingdoeleinden sturen (optioneel)."
    },
    {
        "id": "newProjectCustomerInfoErrorGsmNumber",
        "FR": "Votre numéro de GSM ne peut pas contenir de lettre.",
        "NL": "Uw GSM-nummer mag geen letter bevatten."
    },
    {
        "id": "newProjectCustomerInfoErrorLastName",
        "FR": "Votre nom ne peut pas contenir de chiffre",
        "NL": "Je naam mag geen cijfers bevatten."
    },
    {
        "id": "newProjectCustomerInfoErrorFirstName",
        "FR": "Votre nom ne peut pas contenir de chiffre",
        "NL": "Je naam mag geen cijfers bevatten."
    },
    {
        "id": "newProjectCustomerInfoErrorEmail",
        "FR": "Votre email n'est pas correct",
        "NL": "Je e-mail adres is niet correct"
    },
    {
        "id": "newProjectCustomerInfoErrorDivHeader",
        "FR": "Le(s) champ(s) suivant(s) n’a/ont pas été rempli(s) correctement",
        "NL": "De volgende velden zijn niet correct ingevuld:"
    },
    {
        "id": "newProjectCustomerInfoErrorDivLastName",
        "FR": "Nom",
        "NL": "Naam"
    },
    {
        "id": "newProjectCustomerInfoErrorDivFirsName",
        "FR": "Prénom",
        "NL": "Voornaam"
    },
    {
        "id": "newProjectCustomerInfoErrorDivGsm",
        "FR": "Numéro de GSM",
        "NL": "GSM-nummer"
    },
    {
        "id": "newProjectCustomerInfoErrorDivEmail",
        "FR": "Email",
        "NL": "E-mail"
    },
    {
        "id": "newProjectCustomerInfoErrorDivPrivacy",
        "FR": "Votre accord sur la politique de confidentialité est obligatoire",
        "NL": "Je akkoord met het privacybeleid is verplicht."
    },
    {
        "id": "newProjectConfirmationHeader",
        "FR": "Merci !",
        "NL": "Bedankt!"
    },
    {
        "id": "newProjectConfirmationInformationText",
        "FR": "L’homme de métier le plus adéquat en fonction de votre demande va prendre contact avec vous dans les deux jours ouvrables. Vous aurez ensuite la possibilité de discuter avec lui du meilleur moment pour planifier sa prestation.",
        "NL": "De meest geschikte vakman voor jouw verzoek zal binnen twee werkdagen contact met je opnemen. Daarna kan je met hem bespreken wat het beste tijdstip is voor zijn dienstverlening."
    },
    {
        "id": "newProjectConfirmationEmailText",
        "FR": "Un e-mail récapitulatif reprenant tous les détails de votre demande vous a été envoyé.",
        "NL": "Een samenvattende e-mail met alle details van je aanvraag is naar jou verzonden."
    },
    {
        "id": "newProjectAfterSuccessStepsTitle",
        "FR": "Quelle est la prochaine étape ?",
        "NL": "Wat is de volgende stap?"
    },
    {
        "id": "newProjectAfterSuccessStepsText",
        "FR": "Pas toujours évident de trouver rapidement la perle rare quand on est confronté à une panne ou autre petit pépin ! Pour vous aider à trouver les meilleurs corps de métier de chaque région, AXA a développé cette application.",
        "NL": "Niet altijd gemakkelijk om snel de juiste vakman te vinden wanneer je te maken krijgt met een storing of een ander klein probleem! Om je te helpen de beste vakmensen in elke regio te vinden, heeft AXA deze applicatie ontwikkeld."
    },
    {
        "id": "newProjectAfterSuccessStep1Title",
        "FR": "Vous êtes contacté dans les deux jours ouvrables",
        "NL": "Binnen de twee werkdagen word je gecontacteerd"
    },
    {
        "id": "newProjectAfterSuccessStep2Title",
        "FR": "Fixez un rendez-vous",
        "NL": "Maak een afspraak"
    },
    {
        "id": "newProjectAfterSuccessStep3Title",
        "FR": "Profitez d’une intervention de qualité",
        "NL": "Profiteer van een kwalitatieve interventie"
    },
    {
        "id": "newProjectAfterSuccessStep1Text",
        "FR": "Le professionnel le plus indiqué vous contactera dans les deux jours ouvrables afin de pouvoir établir un devis.",
        "NL": "De meest geschikt specialist zal binnen de twee werkdagen contact met je opnemen om een offerte op te stellen."
    },
    {
        "id": "newProjectAfterSuccessStep2Text",
        "FR": "Convenez du meilleur moment pour effectuer les travaux avec l’homme de métier qui a pris contact avec vous.",
        "NL": "Bepaal samen met de vakman het beste tijdstip voor de werkzaamheden nadat hij met jou contact heeft opgenomen."
    },
    {
        "id": "newProjectAfterSuccessStep3Text",
        "FR": "En fonction du problème que vous nous avez exposé, nous vous proposons le professionnel le plus adéquat dans votre région ou le plus près possible de chez vous.",
        "NL": "Afhankelijk van het probleem dat je ons hebt voorgelegd, bieden we je de meest geschikte specialist in jouw regio of zo dicht mogelijk bij je thuis."
    },
    {
        "id": "newProjectAfterSuccessInsuranceNeedsHeader",
        "FR": "Assurer votre maison contre les frais de réparation imprévus ?",
        "NL": "Uw huis verzekeren tegen onverwachte reparatiekosten?"
    },
    {
        "id": "newProjectAfterSuccessInsuranceNeedsText",
        "FR": "En choisissant notre assurance, vous pouvez vivre sans souci.",
        "NL": "Door te keizen voor onze verzekering, kunt u zorgenvrij wonen."
    },
    {
        "id": "newProjectAfterSuccessHouseHeader",
        "FR": "Avez-vous déjà une assurance incendie AXA ?",
        "NL": "Heb je al een AXA brandverzekering"
    },
    {
        "id": "newProjectAfterSuccessHouseText",
        "FR": "Développez davantage votre assurance existante avec ces options",
        "NL": "Breid je bestaande verzekering verder uit met deze opties"
    },
    {
        "id": "newProjectAfterSuccessExpertHeader",
        "FR": "Pas encore d’assurance incendie AXA ?",
        "NL": "Nog geen AXA brandverzekering?"
    },
    {
        "id": "newProjectAfterSuccessExpertText",
        "FR": "Notre assurance incendie vous couvre pour",
        "NL": "Onze brandverzekering dekt je voor"
    },
    {
        "id": "newProjectAfterSuccessHouseList1",
        "FR": "Vol",
        "NL": "Diefstal"
    },
    {
        "id": "newProjectAfterSuccessHouseList2",
        "FR": "Terrasse & jardin",
        "NL": "Terras & tuin"
    },
    {
        "id": "newProjectAfterSuccessHouseList3",
        "FR": "Piscine",
        "NL": "Zwembad"
    },
    {
        "id": "newProjectAfterSuccessHouseList4",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "newProjectAfterSuccessHouseContanctBrokerBtn",
        "FR": "CONTACTEZ VOTRE COURTIER",
        "NL": "CONTACTEER JE MAKELAAR"
    },
    {
        "id": "newProjectAfterSuccessHouseMoreInfoBtn",
        "FR": "PLUS D'INFO",
        "NL": "MEER INFO"
    },
    {
        "id": "newProjectAfterSuccessExpertList1",
        "FR": "Incendie, tempête,...",
        "NL": "Brand, storm, ..."
    },
    {
        "id": "newProjectAfterSuccessExpertList2",
        "FR": "Dégâts d’eau ou d’électricité",
        "NL": "Water- of elektriciteitsschade"
    },
    {
        "id": "newProjectAfterSuccessExpertList3",
        "FR": "Bris et fissures de verre, vandalisme",
        "NL": "Breken en barsten van glas, vandalisme"
    },
    {
        "id": "newProjectAfterSuccessExpertList4",
        "FR": "Assistance 24/7",
        "NL": "24/7 bijstand"
    },
    {
        "id": "newProjectAfterSuccessExpertList5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "newProjectAfterSuccessExpertCalculateBtn",
        "FR": "CALCULEZ VOTRE PRIX",
        "NL": "BEREKEN JE PRIJS"
    },
    {
        "id": "newProjectAfterSuccessExpertMoreInfoBtn",
        "FR": "PLUS D'INFOS",
        "NL": "MEER INFO"
    },

    {
        "id": "cat-heatingAndCooling",
        "FR": "Chauffage & climatisation",
        "NL": "Verwarming & verkoeling"
    },
    {
        "id": "cat-plumbingAndPipes",
        "FR": "Sanitaires & conduites",
        "NL": "Sanitair & leidingen"
    },
    {
        "id": "cat-electricityCraftsmanship",
        "FR": "Finitions & électricité",
        "NL": "Afwerking & elektriciteit"
    },
    {
        "id": "cat-gardenFacadeRoof",
        "FR": "Jardin, façade & toiture",
        "NL": "Tuin, gevel & dak"
    },
    {
        "id": "cat-certificates",
        "FR": "",
        "NL": ""
    },
    {
        "id": "cat-generalChores",
        "FR": "",
        "NL": ""
    },
    {
        "id": "subCat-heatingMaintenance",
        "FR": "Chauffage - entretien",
        "NL": "Verwarming - onderhoud"
    },
    {
        "id": "subCat-heatingInstallationRepairAndDemolition",
        "FR": "Chauffage - installation & réparation",
        "NL": "Verwarming - installatie & herstelling"
    },
    {
        "id": "subCat-radiatorsAndHeatPumps",
        "FR": "Radiateurs & pompes à chaleur",
        "NL": "Radiatoren & warmtepompen"
    },
    {
        "id": "subCat-airConditioning",
        "FR": "Climatisation",
        "NL": "Airconditioning"
    },
    {
        "id": "subCat-sewerPipesAndPlumbing",
        "FR": "Égouts, tuyauteries & sanitaires",
        "NL": "Riool, leidingen & sanitair"
    },
    {
        "id": "subCat-moistureAndLeaks",
        "FR": "Humidité & fuites",
        "NL": "Vocht & lekken"
    },
    {
        "id": "subCat-floorsAndTiles",
        "FR": "Carrelages",
        "NL": "Tegels"
    },
    {
        "id": "subCat-paintingAndFurnishing",
        "FR": "Peinture & décoration",
        "NL": "Schilderen & decoratie"
    },
    {
        "id": "subCat-electricity",
        "FR": "Électricité",
        "NL": "Elektriciteit"
    },
    {
        "id": "subCat-guttersAndChimneys",
        "FR": "Gouttières & cheminées",
        "NL": "Dakgoten & schouwen"
    },
    {
        "id": "subCat-paintingFacade",
        "FR": "Peinture de façade",
        "NL": "Schilderen van de gevel"
    },
    {
        "id": "subCat-gardening",
        "FR": "",
        "NL": ""
    },
    {
        "id": "subCat-pruning",
        "FR": "Travaux d'élagage",
        "NL": "Snoei werkzaamheden"
    },
    {
        "id": "subCat-epc",
        "FR": "",
        "NL": ""
    },
    {
        "id": "subCat-asbestos",
        "FR": "",
        "NL": ""
    },
    {
        "id": "subCat-handyman",
        "FR": "",
        "NL": ""
    },

    {
        "id": "subCat-heatingMaintenanceDescr",
        "FR": "L’entretien régulier de vos appareils sanitaires est essentiel pour votre sécurité, mais aussi pour éviter que les pièces se détériorent trop rapidement, ce qui pourrait provoquer une panne. Faites appel à un plombier-chauffagiste pour procéder à la révision de votre chauffe-eau ou de votre chaudière.",
        "NL": "Regelmatig onderhoud van je sanitair toestel is essentieel voor je veiligheid en om te voorkomen dat onderdelen te snel verslijten, wat een storing kan veroorzaken. Schakel een loodgieter-verwarmingsspecialist in om je boiler of verwarmingsketel te laten nakijken."
    },
    {
        "id": "subCat-heatingInstallationRepairAndDemolitionDescr",
        "FR": "L’installation d’appareils de chauffage réclame une expertise toute particulière afin de garantir votre sécurité, mais aussi un travail de qualité, efficace à long terme. Un chauffagiste agréé veillera notamment, avant même de commencer l‘installation, à la conformité des raccordements ainsi qu’à leur étanchéité.",
        "NL": "De installatie van verwarmingstoestellen vereist specifieke expertise om je veiligheid te garanderen, maar ook om kwaliteitsvol werk te leveren dat op lange termijn efficiënt is. Een erkende verwarmingsspecialist zal onder andere voorafgaand aan de installatie zorgen voor de naleving van de aansluitingen en hun lekdichtheid."
    },
    {
        "id": "subCat-radiatorsAndHeatPumpsDescr",
        "FR": "Pour distribuer la chaleur dans toutes les pièces de votre habitation, vous disposez de radiateurs, avec ou sans pompe à chaleur. ",
        "NL": "Om warmte te verdelen in alle kamers van jouw huis, heb je radiatoren, met of zonder warmtepomp."
    },
    {
        "id": "subCat-airConditioningDescr",
        "FR": "Un système de climatisation vous permet non seulement de réguler la température dans vos espaces intérieurs (produire du froid, ou également du chaud si vous optez pour une climatisation réversible), mais vous permet aussi de contrôler le taux d’humidité et d’améliorer la qualité de l’air intérieur grâce à un système de filtrage.",
        "NL": "Een airconditioning stelt je niet alleen in staat om de temperatuur in jouw binnenruimtes te reguleren (koelen of ook verwarmen als je kiest voor omkeerbare airconditioning), maar ook om de vochtigheidsgraad te beheersen en de luchtkwaliteit te verbeteren met een filtersysteem."
    },
    {
        "id": "subCat-sewerPipesAndPlumbingDescr",
        "FR": "Besoin d’un plombier pour installer ou réparer des canalisations, des sanitaires ou pour des travaux à vos égouts ? Ou pour un problème d’humidité ou une fuite ? ",
        "NL": "Heb je een loodgieter nodig voor de installatie of reparatie van leidingen, sanitair of werkzaamheden aan je riolering? Of heb je last van vochtproblemen of een lekkage?"
    },
    {
        "id": "subCat-moistureAndLeaksDescr",
        "FR": "Il n’y a rien de plus désagréable dans une habitation que l’apparition de taches d’humidité ou de moisissure sur les murs. D’autant plus que ces dégâts peuvent rapidement s’aggraver et même avoir un impact sur notre santé. Bref, dès que ces traces apparaissent, consultez sans attendre un spécialiste.",
        "NL": "Er is niets vervelender in een woning dan het verschijnen van vochtvlekken of schimmel op de muren. Vooral omdat deze schade snel kan verergeren en zelfs invloed op onze gezondheid kan hebben. Raadpleeg dus direct een specialist zodra deze sporen verschijnen."
    },
    {
        "id": "subCat-floorsAndTilesDescr",
        "FR": "Opter pour les carrelages pour le revêtement de vos sols intérieurs ou de votre terrasse est un choix synonyme de facilité d’entretien et longévité. Voilà pourquoi c’est la solution idéale dans les espaces exposés à l’humidité ou à une activité plus salissante : cuisine, salle de bain, WC... La pose murale est d’ailleurs également fréquente dans ce type de situation.",
        "NL": "Kiezen voor tegels als bekleding voor je binnen- of buitenvloeren is een keuze die synoniem staat voor gemakkelijk onderhoud en duurzaamheid. Daarom is het de ideale oplossing in ruimtes die blootstaan aan vochtigheid of intensiever gebruik, zoals de keuken, badkamer, WC... Ook wandtegels komen veel voor in dergelijke situaties."
    },
    {
        "id": "subCat-paintingAndFurnishingDescr",
        "FR": "Vous allez bientôt déménager ou il est temps de rafraîchir le logement que vous occupez depuis belle lurette ? Ou alors c’est à votre coin terrasse ou votre véranda que vous voulez donner un petit coup d’éclat ? À moins que vous ayez été confronté à un dégât des eaux ou autre accident de ce type... Autant de circonstances où vous aurez probablement besoin de faire appel à un peintre et/ou même un décorateur.",
        "NL": "Ga je binnenkort verhuizen of is het tijd om je lang bewoonde woning op te frissen? Of wil je je terras of veranda wat nieuw leven inblazen? Misschien heb je te maken gehad met waterschade of een ander soort ongeluk... Dit zijn allemaal situaties waarin je waarschijnlijk een schilder en/of decorateur nodig zult hebben."
    },
    {
        "id": "subCat-electricityDescr",
        "FR": "Besoin d’un électricien pour une nouvelle installation, un dépannage ou une mise en conformité ? ",
        "NL": "Heb je een elektricien nodig voor een nieuwe installatie, een reparatie of een conformiteitscontrole?"
    },
    {
        "id": "subCat-guttersAndChimneysDescr",
        "FR": "Ce ne sont pas toujours les travaux qu’on préfère effectuer, mais ils sont pourtant très importants pour préserver le bon état général de votre habitation. Car une gouttière qui fuit ou des corniches qui débordent et détrempent vos murs peuvent occasionner bien des dégâts... et ne parlons même pas d’une cheminée qui s’encrasse, ce qui peut parfois même mettre votre santé ou votre sécurité en péril ! ",
        "NL": "Dit zijn niet altijd de meest geliefde klussen, maar wel essentieel om de volledige staat van je woning te behouden. Want een lekkende dakgoot of overlopende dakranden die je muren doordrenken, kunnen veel schade veroorzaken ... En dan hebben we het nog niet eens over een vervuilde schoorsteen, wat soms zelfs je gezondheid of veiligheid in gevaar kan brengen! "
    },
    {
        "id": "subCat-paintingFacadeDescr",
        "FR": "Votre façade fait grise mine ? Il est grand temps de lui donner un petit coup de fraîcheur ? Ou alors vous venez d’emménager dans une nouvelle habitation et il vous faut encore procéder aux finitions, notamment aux peintures extérieures ? utant de circonstances où vous aurez probablement besoin de faire appel à un peintre",
        "NL": "Ziet je gevel er wat dof uit? Is het hoog tijd om hem op te frissen? Of ben je net verhuisd naar een nieuwe woning en moeten de laatste afwerkingen, waaronder het buitenschilderwerk, nog worden gedaan? Dit zijn allemaal situaties waarin je waarschijnlijk een schilder en/of decorateur nodig zult hebben."
    },
    {
        "id": "subCat-gardeningDescr",
        "FR": "",
        "NL": ""
    },
    {
        "id": "subCat-pruningDescr",
        "FR": "Vous avez des arbres ou des massifs dont le branchage déborde sur l’espace public ou sur la propriété de vos voisins ? ",
        "NL": "Heb je bomen of struiken waarvan de takken overhangen naar de openbare ruimte of het eigendom van je buren? Dan is het hoog tijd om ze te snoeien! "
    },
    {
        "id": "subCat-epcDescr",
        "FR": "",
        "NL": ""
    },
    {
        "id": "subCat-asbestosDescr",
        "FR": "",
        "NL": ""
    },
    {
        "id": "subCat-handymanDescr",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-boiler",
        "FR": "Chauffe-eau",
        "NL": "Boiler"
    },
    {
        "id": "service-cvKetel",
        "FR": "Chaudière chauffage central",
        "NL": "Centrale verwarmingsketel"
    },
    {
        "id": "service-fuelOilBoiler",
        "FR": "Chaudière au mazout",
        "NL": "Stookolieketel"
    },
    {
        "id": "service-radiators",
        "FR": "Radiateurs",
        "NL": "Radiatoren"
    },
    {
        "id": "service-heatPump",
        "FR": "Pompe à chaleur",
        "NL": "Warmtepomp"
    },
    {
        "id": "service-installationMaintenance",
        "FR": "Climatisation",
        "NL": "Airconditioning"
    },
    {
        "id": "service-pipes",
        "FR": "Tuyauterie",
        "NL": "Leidingen"
    },
    {
        "id": "service-wcShowerBathAndTaps",
        "FR": "WC, douche, baignoire & robinetterie",
        "NL": "WC, douche, bad & kranen"
    },
    {
        "id": "service-septicTank",
        "FR": "Fosse septique",
        "NL": "Septische tank"
    },
    {
        "id": "service-blockages",
        "FR": "Bouchons",
        "NL": "Verstoppingen"
    },
    {
        "id": "service-moisture",
        "FR": "Humidité",
        "NL": "Vocht"
    },
    {
        "id": "service-leak",
        "FR": "Fuite",
        "NL": "Lekken"
    },
    {
        "id": "service-parquet",
        "FR": "Parquet",
        "NL": "Parket"
    },
    {
        "id": "service-floorTiles",
        "FR": "Carrelages",
        "NL": "Tegels"
    },
    {
        "id": "service-PaintingAndFurnishing",
        "FR": "Peinture & décoration",
        "NL": "Schilderen & inrichting"
    },
    {
        "id": "service-electricalInstallation",
        "FR": "Electricité général",
        "NL": "Algemene electriciteit"
    },
    {
        "id": "service-homeAutomation",
        "FR": "Domotica - smart living",
        "NL": "Domotica - smart living"
    },
    {
        "id": "service-alarmSystem",
        "FR": "Alarmes & cameras",
        "NL": "Alarmsystemen & bewakingscamera's"
    },
    {
        "id": "service-cleaningGutters",
        "FR": "Nettoyage des gouttieres",
        "NL": "Dakgoten kuisen"
    },
    {
        "id": "service-chimneys",
        "FR": "Cheminées",
        "NL": "Schoorsteenvegen"
    },
    {
        "id": "service-paintingFacade",
        "FR": "Peinture de facade",
        "NL": "Schilderen van gevel"
    },
    {
        "id": "service-pruning",
        "FR": "Elagage",
        "NL": "Snoeien"
    },
    {
        "id": "service-epcCertification",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-asbestosCertification",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-handymanChores",
        "FR": "",
        "NL": ""
    },

    {
        "id": "service-boilerCardTitle",
        "FR": "Chauffe-eau",
        "NL": "Boiler"
    },
    {
        "id": "service-cvKetelCardTitle",
        "FR": "Chaudière chauffage central",
        "NL": "Centrale verwarmings ketel"
    },
    {
        "id": "service-boilerCardTitle",
        "FR": "Chauffe-eau",
        "NL": "Boiler"
    },
    {
        "id": "service-cvKetelCardTitle",
        "FR": "Chaudière chauffage central",
        "NL": "Centrale verwarmings ketel"
    },
    {
        "id": "service-fuelOilBoilerCardTitle",
        "FR": "Chaudière au mazout",
        "NL": "Stookolieketel"
    },
    {
        "id": "service-radiatorsCardTitle",
        "FR": "Radiateurs",
        "NL": "Radiatoren"
    },
    {
        "id": "service-heatPumpCardTitle",
        "FR": "Pompe à chaleur",
        "NL": "Warmtepomp"
    },
    {
        "id": "service-installationMaintenanceCardTitle",
        "FR": "Climatisation",
        "NL": "Airconditioning"
    },
    {
        "id": "service-pipesCardTitle",
        "FR": "Tuyauterie",
        "NL": "Leidingen"
    },
    {
        "id": "service-wcShowerBathAndTapsCardTitle",
        "FR": "WC, douche, baignoire & robinetterie",
        "NL": "WC, douche, bad & kranen"
    },
    {
        "id": "service-septicTankCardTitle",
        "FR": "Fosse septique",
        "NL": "Septische tank"
    },
    {
        "id": "service-blockagesCardTitle",
        "FR": "Bouchons",
        "NL": "Verstoppingen"
    },
    {
        "id": "service-moistureCardTitle",
        "FR": "Humidité",
        "NL": "Vocht"
    },
    {
        "id": "service-leakCardTitle",
        "FR": "Fuite",
        "NL": "Lekken"
    },
    {
        "id": "service-parquetCardTitle",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-floorTilesCardTitle",
        "FR": "Carrelages",
        "NL": "Tegels"
    },
    {
        "id": "service-generalChoresCardTitle",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-electricalInstallationCardTitle",
        "FR": "Électricité générale",
        "NL": "Algemene elektriciteit"
    },
    {
        "id": "service-homeAutomationCardTitle",
        "FR": "Domotique",
        "NL": "Domotica"
    },
    {
        "id": "service-alarmSystemCardTitle",
        "FR": "Alarmes & caméras",
        "NL": "Alarmsystemen & bewakingscamera's"
    },
    {
        "id": "service-cleaningGuttersCardTitle",
        "FR": "Nettoyage des gouttières",
        "NL": "Dakgoten reinigen"
    },
    {
        "id": "service-chimneysCardTitle",
        "FR": "Cheminées",
        "NL": "Schoorsteenvegen"
    },
    {
        "id": "service-paintingFacadeCardTitle",
        "FR": "Peinture de facade",
        "NL": "Gevel schilderen"
    },
    {
        "id": "service-gardeningChoresCardTitle",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-pruningCardTitle",
        "FR": "Elagage",
        "NL": "Snoeien"
    },
    {
        "id": "service-epcCertificationCardTitle",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-asbestosCertificationCardTitle",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-handymanChoresCardTitle",
        "FR": "",
        "NL": ""
    },

    {
        "id": "questionWorkDone1",
        "FR": "Quel type de travaux faut-il effectuer ?",
        "NL": "Wat voor werk moet er gebeuren? "
    },
    {
        "id": "questionTilingLocation",
        "FR": "Où les carrelages doivent-ils être placés?",
        "NL": "Waar vindt het tegelen plaats? "
    },
    {
        "id": "questionFinishType",
        "FR": "Quel type de finition faut-il prévoir?",
        "NL": "Welke soort afwerking is vereist?"
    },
    {
        "id": "questionWorkDone2",
        "FR": " Quel type de travaux faut-il effectuer?",
        "NL": "Wat voor werk moet er gebeuren?"
    },
    {
        "id": "questionHauseAge",
        "FR": "De quand date votre maison?",
        "NL": "Hoe oud is uw huis"
    },
    {
        "id": "questionSurfaceCondition",
        "FR": "Dans quel état se trouve la surface à traiter?",
        "NL": "Wat is de staat van het oppervlak waaraan gewerkt moet worden?"
    },
    {
        "id": "questionHeatingFuel",
        "FR": "Quel type d'énergie utilisez-vous pour votre installation de chauffage ? ",
        "NL": "Waarop werkt uw verwarmingsinstallatie?"
    },

    {
        "id": "answerRepair1",
        "FR": "Réparation",
        "NL": "Herstelling"
    },
    {
        "id": "answerNewInstallation1",
        "FR": "Nouvelle installation",
        "NL": "Nieuwe installatie"
    },
    {
        "id": "answerMaintenance",
        "FR": "Entretien",
        "NL": "Onderhoud"
    },
    {
        "id": "answerAssembly",
        "FR": "Montage",
        "NL": "Montage"
    },
    {
        "id": "answerOther1",
        "FR": "Autre",
        "NL": "Andere"
    },
    {
        "id": "answerWalls",
        "FR": "Murs",
        "NL": "Muren"
    },
    {
        "id": "answerFloor",
        "FR": "Sol",
        "NL": "Vloer"
    },
    {
        "id": "answerStairs",
        "FR": "Escalier",
        "NL": "Trappen"
    },
    {
        "id": "answerOther2",
        "FR": "Autre",
        "NL": "Andere"
    },
    {
        "id": "answerPaint",
        "FR": "Peinture",
        "NL": "Verf"
    },
    {
        "id": "answerWallpaper",
        "FR": "Papier peint",
        "NL": "Behangpapier"
    },
    {
        "id": "answerRepair2",
        "FR": "Réparation",
        "NL": "Herstelling"
    },
    {
        "id": "answerNewInstallation2",
        "FR": "Nouvelle installation",
        "NL": "Nieuwe installatie"
    },
    {
        "id": "answerComplianceTest",
        "FR": "Test de conformité",
        "NL": "Keuring elektrische installatie"
    },
    {
        "id": "answerOther3",
        "FR": "Autre",
        "NL": "Andere"
    },
    {
        "id": "answerLessThan10",
        "FR": "Moins de 10 ans",
        "NL": "Minder dan 10 jaar"
    },
    {
        "id": "answer10orMore",
        "FR": "10 ans ou plus",
        "NL": "10 jaar of meer"
    },
    {
        "id": "answerPrefectCondition",
        "FR": "Parfait état",
        "NL": "Perfecte staat"
    },
    {
        "id": "answerNormalCondition",
        "FR": "Etat normal: la surface ne nécessite que de petites réparations",
        "NL": "Gewone staat: het oppervlak heeft kleine herstellingen nodig"
    },
    {
        "id": "answerBadCondition",
        "FR": "Mauvais état : la surface nécessite de grosses réparations",
        "NL": "Slechte staat: oppervlak heeft grote herstelling nodig"
    },
    {
        "id": "answerOther4",
        "FR": "Autre",
        "NL": "Andere"
    },
    {
        "id": "answerFuelOil",
        "FR": "Mazout",
        "NL": "Stookolie"
    },
    {
        "id": "answeGasr",
        "FR": "Gaz",
        "NL": "Gas"
    },
    {
        "id": "answerElectricity",
        "FR": "Electricité",
        "NL": "Elektriciteit"
    },
    {
        "id": "answerHeatPump",
        "FR": "Pompe à chaleur",
        "NL": "Warmtepomp"
    },
    {
        "id": "answerOther5",
        "FR": "Autre",
        "NL": "Andere"
    },

    {
        "id": "buttonRequestYourQuote",
        "FR": "DEMANDEZ UN PROFESSIONNEL",
        "NL": "VIND DE JUISTE SPECIALIST"
    },
    {
        "id": "btnCloseOffcanvas",
        "FR": "FERMER",
        "NL": "SLUITEN"
    },
    {
        "id": "btnCloseModal",
        "FR": "FERMER",
        "NL": "SLUITEN"
    },
    {
        "id": "btnProjectForward",
        "FR": "SUIVANT",
        "NL": "VOLGENDE"
    },
    {
        "id": "btnNoExpertProjectForward",
        "FR": "SUIVANT",
        "NL": "VOLGENDE"
    },
    {
        "id": "btnNoExpertBack",
        "FR": "RETOUR",
        "NL": "TERUG"
    },
    {
        "id": "btnOpenFileDialog",
        "FR": "SÉLECTIONNEZ VOS FICHIERS",
        "NL": "SELECTEER UW DOCUMENTEN"
    },
    {
        "id": "btnProjectSend",
        "FR": "ENVOYER",
        "NL": "VERSTUUR"
    },
    {
        "id": "service-boilerBulletPoint1",
        "FR": "Nettoyage des pièces",
        "NL": "Onderdelen reinigen"
    },
    {
        "id": "service-boilerBulletPoint2",
        "FR": "Vérification de la résistance ou du brûleur",
        "NL": "Weerstand of brander controleren"
    },
    {
        "id": "service-boilerBulletPoint3",
        "FR": "Contrôle du débit",
        "NL": "Doorstroming controleren"
    },
    {
        "id": "service-boilerBulletPoint4",
        "FR": "Vérification du dispositif antitartre",
        "NL": "Ontkalkingsysteem controleren"
    },
    {
        "id": "service-boilerBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-cvKetelBulletPoint1",
        "FR": "Nettoyage complet de l’appareil de chauffage",
        "NL": "Volledige reiniging van het verwarmingstoestel"
    },
    {
        "id": "service-cvKetelBulletPoint2",
        "FR": "Réglage du brûleur",
        "NL": "Brander aanpassen"
    },
    {
        "id": "service-cvKetelBulletPoint3",
        "FR": "Contrôle de la pression",
        "NL": "Druk controleren"
    },
    {
        "id": "service-cvKetelBulletPoint4",
        "FR": "Vérification de l’étanchéité du conduit de cheminée",
        "NL": "Controle op lekdichtheid van de schoorsteen"
    },
    {
        "id": "service-cvKetelBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-fuelOilBoilerBulletPoint1",
        "FR": "Dépannage",
        "NL": "Onderhoud en problemen oplossen"
    },
    {
        "id": "service-fuelOilBoilerBulletPoint2",
        "FR": "Remplacement de pièces défectueuses ou usées",
        "NL": "Vervanging van defecte of versleten onderdelen"
    },
    {
        "id": "service-fuelOilBoilerBulletPoint3",
        "FR": "Détection de fuite éventuelle",
        "NL": "Lekdetectie"
    },
    {
        "id": "service-fuelOilBoilerBulletPoint4",
        "FR": "Proposition de solutions alternatives ",
        "NL": "Voorstel van alternatieve oplossingen "
    },
    {
        "id": "service-fuelOilBoilerBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-radiatorsBulletPoint1",
        "FR": "Nouvelle installation",
        "NL": "Nieuwe installatie"
    },
    {
        "id": "service-radiatorsBulletPoint2",
        "FR": "Réparations",
        "NL": "Herstelling"
    },
    {
        "id": "service-radiatorsBulletPoint3",
        "FR": "Remplacement de pièces défectueuses",
        "NL": "Vervanging van deffecte onderdelen"
    },
    {
        "id": "service-radiatorsBulletPoint4",
        "FR": "Purge",
        "NL": "Ontluchten"
    },
    {
        "id": "service-radiatorsBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-heatPumpBulletPoint1",
        "FR": "Nouvelle installation",
        "NL": "Nieuwe installatie"
    },
    {
        "id": "service-heatPumpBulletPoint2",
        "FR": "Réparations",
        "NL": "Herstellingen"
    },
    {
        "id": "service-heatPumpBulletPoint3",
        "FR": "Remplacement de pièces défectueuses",
        "NL": "Vervanging van deffecte onderdelen"
    },
    {
        "id": "service-heatPumpBulletPoint4",
        "FR": "Entretien",
        "NL": "Onderhoud"
    },
    {
        "id": "service-heatPumpBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-installationMaintenanceBulletPoint1",
        "FR": "Nouvelle installation",
        "NL": "Nieuwe installatie"
    },
    {
        "id": "service-installationMaintenanceBulletPoint2",
        "FR": "Réparations",
        "NL": "Herstellingen"
    },
    {
        "id": "service-installationMaintenanceBulletPoint3",
        "FR": "Remplacement de pièces défectueuses",
        "NL": "Vervanging van deffecte onderdelen"
    },
    {
        "id": "service-installationMaintenanceBulletPoint4",
        "FR": "Entretien",
        "NL": "Onderhoud"
    },
    {
        "id": "service-installationMaintenanceBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-pipesBulletPoint1",
        "FR": "Remplacement des vieilles conduites",
        "NL": "Vervanging van oude leidingen"
    },
    {
        "id": "service-pipesBulletPoint2",
        "FR": "Détections des fuites",
        "NL": "Detectie van lekken"
    },
    {
        "id": "service-pipesBulletPoint3",
        "FR": "Réparation d’un tuyau qui fuit",
        "NL": "Reparatie van lekken"
    },
    {
        "id": "service-pipesBulletPoint4",
        "FR": "Adaptation des canalisations",
        "NL": "Aanpassing van leidingen"
    },
    {
        "id": "service-pipesBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-wcShowerBathAndTapsBulletPoint1",
        "FR": "Installation et raccordement des toilettes",
        "NL": "Installatie en aansluiting van toiletten"
    },
    {
        "id": "service-wcShowerBathAndTapsBulletPoint2",
        "FR": "Pose et raccordement de baignoire et douche",
        "NL": "Plaatsing en aansluiting van bad en douche"
    },
    {
        "id": "service-wcShowerBathAndTapsBulletPoint3",
        "FR": "Pose et raccordement d'autres sanitaires",
        "NL": "Plaatsing en aansluiting van ander sanitair"
    },
    {
        "id": "service-wcShowerBathAndTapsBulletPoint4",
        "FR": "Montage de toute la robinetterie ad hoc",
        "NL": "Montage van de geschikte kranen"
    },
    {
        "id": "service-wcShowerBathAndTapsBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-septicTankBulletPoint1",
        "FR": "Entretien de la fosse d’aisances",
        "NL": "Onderhoud van de septische put"
    },
    {
        "id": "service-septicTankBulletPoint2",
        "FR": "Débouchage en cas de bouchon ou d’engorgement",
        "NL": "Ontstoppen bij een verstopping "
    },
    {
        "id": "service-septicTankBulletPoint3",
        "FR": "Détection de fuite éventuelle",
        "NL": "Opsporen van eventuele lekken"
    },
    {
        "id": "service-septicTankBulletPoint4",
        "FR": "Effectuer les controles nécessaires",
        "NL": "Uitvoeren van de nodige controles"
    },
    {
        "id": "service-septicTankBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-blockagesBulletPoint1",
        "FR": "Débouchage d’une conduite",
        "NL": "Ontstoppen van leidingen"
    },
    {
        "id": "service-blockagesBulletPoint2",
        "FR": "Débouchage d’un évier",
        "NL": "ontstoppen van gootsteen"
    },
    {
        "id": "service-blockagesBulletPoint3",
        "FR": "Déboucher d'autres appareils de plomberie",
        "NL": "Ontstoppen van ander sanitair"
    },
    {
        "id": "service-blockagesBulletPoint4",
        "FR": "Déboucher un égout",
        "NL": "Ontstoppen van een riool"
    },
    {
        "id": "service-blockagesBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-moistureBulletPoint1",
        "FR": "Mur taché ou détrempé",
        "NL": "Vlekken of doorweekte muren"
    },
    {
        "id": "service-moistureBulletPoint2",
        "FR": "Sol humide",
        "NL": "Natte vloer"
    },
    {
        "id": "service-moistureBulletPoint3",
        "FR": "Odeurs ",
        "NL": "Geuren"
    },
    {
        "id": "service-moistureBulletPoint4",
        "FR": "Moisissures",
        "NL": "Schimmels"
    },
    {
        "id": "service-moistureBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-leakBulletPoint1",
        "FR": "Fuite d’une conduite ou d’un joint",
        "NL": "Leiding- of voeg lekkage"
    },
    {
        "id": "service-leakBulletPoint2",
        "FR": "Tuyauterie endommagée ",
        "NL": "Beschadigde leidingen"
    },
    {
        "id": "service-leakBulletPoint3",
        "FR": "Tuyauterie arrachée",
        "NL": "Losgeraakte leidingen"
    },
    {
        "id": "service-leakBulletPoint4",
        "FR": "Canalisation corrodée",
        "NL": "Geoxideerde leidingen"
    },
    {
        "id": "service-leakBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-parquetBulletPoint1",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-parquetBulletPoint2",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-parquetBulletPoint3",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-parquetBulletPoint4",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-parquetBulletPoint5",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-floorTilesBulletPoint1",
        "FR": "Conseils pour le choix des carrelages suivant votre usage",
        "NL": "Advies bij de keuze van tegels op basis van jouw gebruik"
    },
    {
        "id": "service-floorTilesBulletPoint2",
        "FR": "Préparation de la surface à carreler",
        "NL": "Voorbereiding van het te betegelen oppervlak"
    },
    {
        "id": "service-floorTilesBulletPoint3",
        "FR": "Pose des carrelages",
        "NL": "Tegels leggen"
    },
    {
        "id": "service-floorTilesBulletPoint4",
        "FR": "Joints & plinthes",
        "NL": "Voegen & plinten"
    },
    {
        "id": "service-floorTilesBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-PaintingAndFurnishingBulletPoint1",
        "FR": "Retrait des anciennes décorations murales",
        "NL": "Verwijderen van oude wanddecoratie"
    },
    {
        "id": "service-PaintingAndFurnishingBulletPoint2",
        "FR": "Traitement des murs",
        "NL": "Behandelen van muren"
    },
    {
        "id": "service-PaintingAndFurnishingBulletPoint3",
        "FR": "Traitement et peinture des fenêtres et des portes",
        "NL": "Behandelen en schilderen van ramen en deuren"
    },
    {
        "id": "service-PaintingAndFurnishingBulletPoint4",
        "FR": "Pose de revêtement mural : du papier peint dans le salon à la peinture de la salle de bains",
        "NL": "Muurbekleding: van behang in de woonkamer tot schilderwerk in de badkamer"
    },
    {
        "id": "service-PaintingAndFurnishingBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-electricalInstallationBulletPoint1",
        "FR": "Installation complète",
        "NL": "Complete installatie"
    },
    {
        "id": "service-electricalInstallationBulletPoint2",
        "FR": "Dépannage (panne d’électricité, court-circuit...)",
        "NL": "Herstelling (stroomstoring, kortsluiting...)"
    },
    {
        "id": "service-electricalInstallationBulletPoint3",
        "FR": "Câblage ou installation/remplacement de boîtiers de dérivation",
        "NL": "Bedrading of installatie/vervanging van verdeeldozen "
    },
    {
        "id": "service-electricalInstallationBulletPoint4",
        "FR": "Mise en conformité d’une ancienne installation",
        "NL": "Aanpassing van een oude installatie"
    },
    {
        "id": "service-electricalInstallationBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-homeAutomationBulletPoint1",
        "FR": "Systèmes d’automatisation pour éclairages, chauffage, alarmes, etc",
        "NL": "Automatiseringssystemen voor verlichting, verwarming, alarmsystemen, enz."
    },
    {
        "id": "service-homeAutomationBulletPoint2",
        "FR": "Équipements connectés contrôlés depuis un écran et/ou votre smartphone",
        "NL": "Geconnecteerde apparaten die worden bediend vanaf een scherm en/of je smartphone"
    },
    {
        "id": "service-homeAutomationBulletPoint3",
        "FR": "D’une simple box domotique à une installation complète sophistiquée",
        "NL": "Van een eenvoudige domoticabox tot een geavanceerde complete installatie"
    },
    {
        "id": "service-homeAutomationBulletPoint4",
        "FR": "Possibilité d’installation progressive",
        "NL": "Mogelijkheid tot geleidelijke installatie"
    },
    {
        "id": "service-homeAutomationBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-alarmSystemBulletPoint1",
        "FR": "Systèmes de contrôle d’accès",
        "NL": "Toegangscontrolesystemen"
    },
    {
        "id": "service-alarmSystemBulletPoint2",
        "FR": "Détecteurs d’ouverture (protection périmétrique)",
        "NL": "Openingsdetectoren (perimeterbeveiliging)"
    },
    {
        "id": "service-alarmSystemBulletPoint3",
        "FR": "Détecteurs de mouvements (protection volumétrique)",
        "NL": "Bewegingsdetectoren (volumetrische beveiliging)"
    },
    {
        "id": "service-alarmSystemBulletPoint4",
        "FR": "Alarme anti-intrusion",
        "NL": "Inbraakalarm"
    },
    {
        "id": "service-alarmSystemBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-cleaningGuttersBulletPoint1",
        "FR": "Nettoyage et démoussage",
        "NL": "Reiniging en verwijdering van mos "
    },
    {
        "id": "service-cleaningGuttersBulletPoint2",
        "FR": "Débouchage éventuel",
        "NL": "Eventuele ontstopping"
    },
    {
        "id": "service-cleaningGuttersBulletPoint3",
        "FR": "Installation ou remplacement éventuel des protections de la gouttière",
        "NL": "Eventuele installatie of vervanging van dakgootbescherming"
    },
    {
        "id": "service-cleaningGuttersBulletPoint4",
        "FR": "Réparation d’éléments des gouttières ou corniches",
        "NL": "Herstel van elementen van dakgoten of dakranden"
    },
    {
        "id": "service-cleaningGuttersBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-chimneysBulletPoint1",
        "FR": "Nettoyage et ramonage de la cheminée",
        "NL": "Schoorsteen reinigen en vegen"
    },
    {
        "id": "service-chimneysBulletPoint2",
        "FR": "Nettoyage du système de chauffage",
        "NL": "Verwarmingssysteem reinigen"
    },
    {
        "id": "service-chimneysBulletPoint3",
        "FR": "Inspection par caméra",
        "NL": "Inspectie met behulp van camera"
    },
    {
        "id": "service-chimneysBulletPoint4",
        "FR": "Dégoudronnage (débistrage)",
        "NL": "Verwijderen van teer (ontteering)"
    },
    {
        "id": "service-chimneysBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-paintingFacadeBulletPoint1",
        "FR": "Préparation de la surface",
        "NL": "Oppervlaktevoorbereiding"
    },
    {
        "id": "service-paintingFacadeBulletPoint2",
        "FR": "Inspection des dommages ",
        "NL": "Schade-inspectie"
    },
    {
        "id": "service-paintingFacadeBulletPoint3",
        "FR": "Effectuer des réparations",
        "NL": "Reparaties uitvoeren"
    },
    {
        "id": "service-paintingFacadeBulletPoint4",
        "FR": "Peindre",
        "NL": "Schilderen"
    },
    {
        "id": "service-paintingFacadeBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-pruningBulletPoint1",
        "FR": "Élagage des arbres",
        "NL": "Snoeien van bomen"
    },
    {
        "id": "service-pruningBulletPoint2",
        "FR": "Taille des arbustes",
        "NL": "Snoeien van struiken"
    },
    {
        "id": "service-pruningBulletPoint3",
        "FR": "Gestion des maladies et des ravageurs",
        "NL": "Ziekte- en plaagbeheer"
    },
    {
        "id": "service-pruningBulletPoint4",
        "FR": "Conseil",
        "NL": "Advies"
    },
    {
        "id": "service-pruningBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-boilerOffCanvasBulletPointSubText",
        "FR": "Comme vous le confirmeront les plombiers-chauffagistes d’AXA Homecare, il est conseillé de procéder régulièrement à l’entretien de votre boiler ou chauffe-eau. Qu’il s’agisse d’un système électrique ou au gaz (y compris les petits chauffe-eau instantanés), voire même d’un dispositif solaire, un bon entretien est en effet fondamental. Si vous êtes locataires, cette obligation légale figure même dans votre bail (excepté pour les installations électriques où cette prestation est conseillée mais pas imposée). Le code civil belge prévoit que les locataires veillent à l’entretien de leur logement, y compris des appareils de chauffage sanitaires. Ils doivent même être en mesure de fournir chaque année la preuve de la vérification de leur installation par une entreprise agréée. Il en va en effet de votre sécurité puisqu’il peut y avoir un risque d’empoisonnement au monoxyde de carbone. Mais comment le tarif d’un tel entretien est-il calculé ? Les tarifs varient suivant le type de modèle et suivant les prestataires. C’est pourquoi AXA Homecare a sélectionné les entreprises de votre région qui offrent le meilleur rapport qualité-prix.",
        "NL": "Zoals bevestigd door de loodgieters-verwarmingsspecialisten van AXA Homecare, wordt regelmatig onderhoud van je boiler of verwarmingsketel aanbevolen. Of het nu een elektrisch of gasgestuurd systeem is (inclusief kleine instant-boilers), of zelfs een zonne-installatie, goed onderhoud is van cruciaal belang. Als je huurder bent, is deze wettelijke verplichting zelfs opgenomen in je huurcontract (behalve voor elektrische installaties waar deze dienst wordt aanbevolen maar niet verplicht is). Het Belgisch Burgerlijk Wetboek vereist dat huurders voor het onderhoud van hun woning zorgen, inclusief verwarmingsapparaten. Ze moeten zelfs elk jaar het bewijs kunnen leveren van een inspectie van hun installatie door een erkend bedrijf. Dit is inderdaad van essentieel belang voor jouw veiligheid, aangezien er een risico op koolmonoxidevergiftiging bestaat. De tarieven variëren afhankelijk van het model en de dienstverleners. Daarom heeft AXA Homecare bedrijven met de beste prijs-kwaliteitverhouding voor jou in jouw regio geselecteerd."
    },
    {
        "id": "service-cvKetelOffCanvasBulletPointSubText",
        "FR": "Tout comme pour les boilers et autres chauffe-eau, l’entretien de votre chaudière de chauffage central est prévu par la loi. Il en va en effet de votre sécurité car un appareil défectueux peut occasionner des problèmes d’intoxication au monoxyde de carbone et même présenter des risques d’explosion. Sans parler des pannes qui peuvent être extrêmement contraignantes, surtout en période hivernale. Le législateur a réglementé l’entretien des chaudières en fonction du type de combustible utilisé. Seules les chaudières électriques ne sont pas visées par cette réglementation (même si un entretien régulier augmentera leur durée de vie). Mais est-c'est au locataire ou au propriétaire de payer et quel est le tarif ? Sauf accord contraire, c’est au locataire de s’acquitter de l’entretien de la chaudière et de pouvoir prouver sa bonne exécution par un organisme agréé au moyen d’une attestation de contrôle/entretien périodique (PEB). Les tarifs varient suivant le type de modèle et suivant les prestataires. C’est pourquoi AXA Homecare a sélectionné les entreprises de votre région qui offrent le meilleur rapport qualité-prix.",
        "NL": "Net zoals voor boilers en andere verwarmingstoestellen, is het onderhoud van jouw centrale verwarmingsketel wettelijk verplicht. Het gaat immers om jouw veiligheid, aangezien een defect toestel koolmonoxidevergiftiging kan veroorzaken en zelfs explosiegevaar kan opleveren. En niet te vergeten de mogelijke storingen die zeer lastig kunnen zijn, vooral in de winter. De wetgever heeft het onderhoud van ketels gereguleerd op basis van het gebruikte type brandstof. Alleen elektrische ketels vallen niet onder deze regulering (zelfs als regelmatig onderhoud hun levensduur verlengt). Maar is het aan de huurder of de eigenaar om te betalen en wat is de prijs? Tenzij anders overeengekomen, moet de huurder de kosten voor ketelonderhoud betalen en moet hij/zij dit kunnen bewijzen met een periodiek controle-/onderhoudsattest (EPC) van een erkende organisatie. De tarieven variëren afhankelijk van het model en de dienstverleners. Daarom heeft AXA Homecare bedrijven met de beste prijs-kwaliteitverhouding voor jou in jouw regio geselecteerd."
    },
    {
        "id": "service-fuelOilBoilerOffCanvasBulletPointSubText",
        "FR": "Il n’y a désormais plus lieu de faire installer une nouvelle chaudière au mazout, qu’il s’agisse d’un modèle à condensation ou à ventouse. En effet, dans le cadre de son Plan Air Climat Énergie (PACE) visant à réduire notre empreinte carbone, l’État belge a légiféré afin d’interdire progressivement la vente de ce type de chauffage. Il n’est par contre pas interdit de continuer à utiliser une installation existante. À condition bien sûr de l’entretenir régulièrement. De même, en cas de panne, vous pouvez encore prolonger la durée de vie de votre chaudière au mazout actuelle en la faisant réparer le cas échéant. Si vous devez remplacer votre chaudière au mazout dans les prochaines années, la plupart du temps, la solution la plus simple sera de vous tourner vers une chaudière au gaz... dont le fonctionnement est sensiblement le même. Quoi qu’il en soit, les chauffagistes recommandés par AXA Homecare sont en mesure de vous présenter les différentes alternatives et de vous dresser un devis.",
        "NL": "Het is nu niet meer relevant om een nieuwe stookolieketel te installeren, of het nu gaat om een condenserend model of een model met afvoer. Immers, in het kader van zijn Klimaat- en Energieplan (KEP) om onze koolstofvoetafdruk te verminderen, heeft de Belgische staat wetten opgesteld om de verkoop van dit type verwarming geleidelijk te verbieden. Het is echter niet verboden om een bestaande installatie te blijven gebruiken. Uiteraard moet je het regelmatig onderhouden. Ook als er een storing is, kun je nog steeds de levensduur van je huidige stookolieketel verlengen door deze indien nodig te laten repareren. Als je in de komende jaren je stookolieketel moet vervangen, is de meest voor de hand liggende oplossing meestal om over te stappen op een gasketel... waarvan de werking aanzienlijk vergelijkbaar is. Hoe dan ook, de door AXA Homecare aanbevolen verwarmingstechnici kunnen je de verschillende alternatieven presenteren en een offerte opstellen."
    },
    {
        "id": "service-radiatorsOffCanvasBulletPointSubText",
        "FR": "Les radiateurs sont sans aucun doute les appareils de distribution de la chaleur les plus répandus. AXA Homecare vous met donc en contact avec nombre de chauffagistes en mesure d’assurer toutes les prestations dont vous pourriez avoir besoin. Qu’il s’agisse d’installer de nouveaux radiateurs, d’effectuer une réparation ou de remplacer une pièce (vanne thermostatique, thermostat, etc)... ou encore tout simplement de purger vos appareils. Qu’il s’agisse de radiateurs à eau ou électriques, à inertie fluide ou sèche. Les professionnels que nous vous recommandons maîtrisent les diverses technologies et travaillent dans le respect des normes en vigueur les plus strictes. Lorsque vous faites appel à un chauffagiste, vous allez payer sa main-d’œuvre (taux horaire qui dépend du type de prestation : installation ou dépannage), le prix du matériel nécessaire, ses frais de déplacement et éventuellement une majoration pour les prestations en dehors des jours ouvrables. Pour avoir un idée du montant que vous devrez débourser, n’hésitez pas à demander avant l’intervention un devis à le professionnel qui vous contactera. Sachez cependant qu’AXA Homecare recherche pour vous les prestataires de votre région qui offrent un très bon rapport qualité-prix",
        "NL": "Radiatoren zijn zonder twijfel de meest voorkomende warmteverdelers.AXA Homecare brengt je in contact met tal van verwarmingsspecialisten die alle diensten kunnen aanbieden die je nodig hebt.Of het nu gaat om het installeren van nieuwe radiatoren, het uitvoeren van reparaties of het vervangen van onderdelen(thermostatische kraan, thermostaat, enz.) ...of gewoon het ontluchten van jouw apparaten.Of ze nu op water of elektriciteit werken, met vloeibare of droge traagheid.De aanbevolen specialisten beheersen diverse technologieën en werken volgens de strengste geldende normen.Wanneer je een beroep doet op een verwarmingsspecialist, betaal je voor zijn werkuren(uurtarief afhankelijk van het soort werk: installatie of reparatie), de kosten van het benodigde materiaal, zijn verplaatsingskosten en een eventuele toeslag voor werkzaamheden buiten de normale werkdagen.Vraag voor de interventie begint een offerte aan de specialist die contact met je opneemt om een idee te krijgen van het bedrag dat je moet betalen.Weet echter dat AXA Homecare bedrijven met de beste prijs- kwaliteitverhouding voor jou in jouw regio heeft geselecteerd."
    },
    {
        "id": "service-heatPumpOffCanvasBulletPointSubText",
        "FR": "De nos jours, dans un contexte de transition écologique, les pompes à chaleur rencontrent un beau succès étant donné leur mode de fonctionnement très « propre ». En effet, comme ces appareils collectent l’énergie thermique présente dans notre environnement naturel (air, eau, sol...) et la transfèrent à votre dispositif de chauffage, ils n’émettent (pratiquement) pas de gaz à effet de serre. De plus, s’ils nécessitent parfois de plus gros travaux au moment de l’installation, ils consomment à l’usage très peu de combustibles fossiles. Vous trouverez dans le réseau d’AXA Homecare nombre de spécialistes disposés à réaliser ce type d’installation pour vous. Que vous optiez pour une pompe à chaleur air-air, air-eau, eau-eau ou géothermique. Le professionnel qui prendra contact avec vous vous fera une offre afin que vous ayez une idée précise du budget à prévoir pour ce type d’installation.",
        "NL": "Tegenwoordig, in het kader van de ecologische transitie, zijn warmtepompen zeer succesvol vanwege hun uiterst \"schone\" werking. Deze apparaten verzamelen namelijk thermische energie uit onze natuurlijke omgeving (lucht, water, grond...) en geven deze door aan jouw verwarmingssysteem. Ze stoten (bijna) geen broeikasgassen uit. Bovendien, hoewel soms bij installatie grotere werken nodig zijn, verbruiken ze in gebruik zeer weinig fossiele brandstoffen. Binnen het AXA Homecare-netwerk vind je veel specialisten die dit soort installaties voor je kunnen uitvoeren. Of je nu kiest voor een lucht-luchtwarmtepomp, lucht-waterwarmtepomp, water-waterwarmtepomp of geothermische warmtepomp. De specialist die contact met je opneemt, zal je een offerte doen zodat je een nauwkeurig idee hebt van het budget dat nodig is voor dit type installatie."
    },
    {
        "id": "service-installationMaintenanceOffCanvasBulletPointSubText",
        "FR": "Un système de climatisation vous permet non seulement de réguler la température dans vos espaces intérieurs (produire du froid, ou également du chaud si vous optez pour une climatisation réversible), mais vous permet aussi de contrôler le taux d’humidité et d’améliorer la qualité de l’air intérieur grâce à un système de filtrage. Il existe différents types d’appareils de climatisation, à unité fixe ou mobile, unique ou multiple, exclusivement pour le froid ou réversible. De plus, si vous souhaitez un système très performant qui produit à la fois de la fraîcheur en été, mais aussi de la chaleur en hiver, vous pourriez vous pencher sur les avantages d’une pompe à chaleur, sachant cependant que celle-ci ne baisse généralement la température que de 5°C maximum. Vous l’aurez compris : les options qui s’offrent à vous en termes de climatisation sont nombreuses et variées. Demandez à être recontacté par un professionnel du réseau AXA Homecare pour en savoir plus et pour obtenir un devis.",
        "NL": "Een airconditioning stelt je niet alleen in staat om de temperatuur in jouw binnenruimtes te reguleren (koelen of ook verwarmen als je kiest voor omkeerbare airconditioning), maar ook om de vochtigheidsgraad te beheersen en de luchtkwaliteit te verbeteren met een filtersysteem. Er zijn verschillende soorten verkoelingstoestellen, vast of mobiel, enkelvoudig of meervoudig, exclusief voor koeling of omkeerbaar. Als je een zeer efficiënt systeem wilt dat in de zomer koelte en in de winter warmte produceert, zou je kunnen overwegen om een warmtepomp te installeren, waarbij de temperatuur meestal niet meer dan 5°C wordt verlaagd. Je hebt begrepen dat er veel en gevarieerde opties zijn als het gaat om airconditioning. Vraag om te worden gecontacteerd door een AXA Homecare-specialist voor meer informatie en een offerte."
    },
    {
        "id": "service-pipesOffCanvasBulletPointSubText",
        "FR": "Les plombiers proposés par AXA Homecare ont été sélectionnés pour leur expertise et leur travail soigné. De plus, vous avez la garantie qu’ils n’utilisent que du matériel professionnel et conforme aux normes en vigueur. Que vous disposiez d’une installation classique (avec plusieurs robinets reliés à un même circuit) ou d’un réseau partagé (avec tuyaux indépendants partant du collecteur central de la chaudière). Ils calculent leurs tarifs en fonction du type de travaux à réaliser. Pour limiter les frais de déplacement, AXA Homecare a répertorié les hommes de métier les plus fiables de votre région. Vous souhaitez connaître le montant précis de la prestation dont vous avez besoin ? Demandez à être recontacté par le professionnel. Complétez déjà tous les champs destinés à préciser l’étendue des travaux à réaliser et vous aurez, dans les 48 heures, des nouvelles du professionnel le plus indiqué pour répondre à votre demande.",
        "NL": "De loodgieters die AXA Homecare aanbiedt, zijn geselecteerd vanwege hun expertise en vakmanschap. Bovendien kan je erop vertrouwen dat zij alleen gebruikmaken van professioneel materiaal dat aan de geldende normen voldoet, of je nu beschikt over een traditioneel leidingnetwerk (met meerdere kranen die op één circuit zijn aangesloten) of een gescheiden netwerk (met afzonderlijke leidingen vanuit de centrale verzamelaar van de ketel). Zijn berekenen hun tarieven op basis van het type uit te voeren werken. Om de verplaatsingskosten te beperken, heeft AXA Homecare de meest betrouwbare vakmensen in jouw regio geselecteerd. Wil je de precieze kosten van de gewenste dienst kennen? Vraag om gecontacteerd te worden door een specialist. Vul alvast alle velden in om de omvang van de uit te voeren werkzaamheden te verduidelijken, en binnen 48 uur ontvang je nieuws van de meest geschikte specialist om aan je verzoek te voldoen."
    },
    {
        "id": "service-wcShowerBathAndTapsOffCanvasBulletPointSubText",
        "FR": "Pour être fiable et fonctionner de manière efficace (notamment en termes de débit, mais aussi d’économie d’eau et d’énergie), une installation sanitaire doit être réalisée par un professionnel disposant des compétences techniques requises. Et même en cas de remplacement d’un élément indépendant, il vous est conseillé de bien réfléchir à ce que vous voulez. Vous souhaitez placer un WC standard ou plutôt un modèle suspendu ? Et doté de quel type de chasse (à tige, poussoir, avec stop ou à double mécanisme...) ? Il en va de même pour vos meubles sanitaires : lavabo sur pied, suspendu ou posé sur un meuble, baignoire ou bac à douche classique, surélevé ou encastré... Côté robinetterie, vous devrez aussi choisir parmi d’innombrables modèles : bec bas ou haut, mélangeur ou mitigeur (simple ou thermostatique), avec ou sans pommeau de douche... sans parler des robinets fonctionnels de votre réseau sanitaire (robinets d’arrêt, de purge, etc). Enfin, avez-vous éventuellement pensé à faire installer un adoucisseur d’eau ? Toutes ces questions ont bien sûr un impact sur la prestation à réaliser. Nous sommes bien placés pour savoir que la moindre fuite peut avoir des conséquences importantes sur votre habitation. C’est pourquoi les plombiers recommandés par AXA Homecare vous garantissent une installation de qualité et conforme aux normes en vigueur. ",
        "NL": "Om langdurig en efficiënt te kunnen functioneren (vooral op het gebied van debiet, water- en energiebesparing) is het belangrijk dat sanitaire installaties worden uitgevoerd door een vakman met de juiste technische vaardigheden. Zelfs bij de vervanging van een afzonderlijk element is het belangrijk om goed na te denken over je wensen. Wil je een standaard toilet plaatsen of geef je de voorkeur aan een hangend model? En welk type spoelmechanisme heb je nodig (stengel, drukknop, met stop of dubbel mechanisme ...)? Hetzelfde geldt voor sanitaire meubels: staande wastafel, hangende wastafels of wastafels op een meubel, klassiek bad of inbouwdouchebak ... Wat kranen betreft moet je ook kiezen uit talloze modellen: lage of hoge uitloop, mengkraan of thermostatische kraan (enkelvoudig of dubbel), met of zonder douchekop … Heb je ook gedacht aan de installatie van een waterontharder? Al deze vragen hebben natuurlijk invloed op de uit te voeren werkzaamheden. We weten maar al te goed dat zelfs de kleinste lekkage ernstige gevolgen kan hebben voor je woning. Daarom garanderen de door AXA Homecare aanbevolen loodgieters een kwalitatieve installatie die voldoet aan de geldende normen."
    },
    {
        "id": "service-septicTankOffCanvasBulletPointSubText",
        "FR": "Bien que vous l’ayez fait vidanger, votre fosse septique dégage des odeurs nauséabondes anormalement persistantes ? Peut-être nécessite-t-elle un entretien plus important ou même des travaux de réparation ? Tout comme les conduites peuvent être obstruées, la fosse d’aisances peut également se retrouver engorgée. Quoi qu’il en soit, il est essentiel de contacter rapidement un spécialiste car ce type de dispositif nécessite une intervention très spécifique. Pour connaître le coût de l’intervention, demandez à être recontacté par un professionnel. Pour ce faire, complétez tous les champs destinés à préciser l’étendue des travaux à réaliser. ",
        "NL": "Heeft je septische put ongewoon aanhoudende onaangename geuren, zelfs nadat hij geleegd is geweest? Misschien is er een groter onderhoud nodig of moeten er zelfs reparatiewerkzaamheden gebeuren? Net zoals de leidingen verstopt kunnen raken, kan dat ook met de septische put gebeuren. In ieder geval is het essentieel om snel een specialist te raadplegen, want dit soort systemen vereist een zeer specifieke interventie. Om de kosten van de interventie te kennen, vraag je best om door een specialist gecontacteerd te worden. Vul hiervoor alle velden in om de omvang van de werkzaamheden te verduidelijken."
    },
    {
        "id": "service-blockagesOffCanvasBulletPointSubText",
        "FR": "L’eau ne s’écoule plus normalement ou plus du tout de votre évier ou de votre baignoire ? Ou - pire - ce sont vos toilettes qui sont bouchées ? Si le problème persiste, ne vous entêtez pas trop à chercher à le résoudre vous-même à coups de produits chimiques. D’abord parce que ceux-ci sont, pour la plupart, nocifs pour votre santé ainsi que pour l’environnement. De plus, si vous en abusez, ils peuvent même endommager vos conduites. Cheveux, résidus et autres particules diverses sont souvent à l’origine des engorgements ainsi que le calcaire et les produits d’hygiène.Un professionnel dispose des outils ad hoc (ventouse, furet, nettoyeur à haute pression) pour venir à bout de la plupart des bouchons qui obstruent vos canalisations. Si c’est l’un de vos égouts qui se bloque régulièrement, il sera en mesure d’identifier le problème en inspectant l’intérieur de vos canalisations au moyen d’une caméra... une précaution qui pourrait vous éviter bien des déboires (fuites, infiltrations, etc). Enfin, s’il recourt à un produit déboucheur, il s’agit de compositions spécialement formulées pour respecter les normes environnementales. Pour connaître le prix de l’intervention d’un plombier pour déboucher votre tuyauterie, demandez à être recontacté par un professionnel. Pour ce faire, complétez tous les champs destinés à préciser l’étendue des travaux à réaliser. ",
        "NL": "Stroomt het water niet normaal of helemaal niet meer weg uit uw gootsteen of bad? Of - erger nog - je toilet is verstopt? Als het probleem blijft aanhouden, probeer dan niet tevergeefs om het zelf op te lossen met chemische producten. Ten eerste omdat de meeste van die producten schadelijk zijn voor je gezondheid en het milieu. Bovendien kunnen ze je leidingen beschadigen als je ze te vaak gebruikt. Haar, afval en andere deeltjes zijn vaak de oorzaak van verstoppingen, net als kalkaanslag en hygiëneproducten. Een specialist beschikt over de juiste gereedschappen (ontstopper, ontstoppingsveer, hogedrukreiniger) om de meeste verstoppingen in je leidingen op te lossen. Als je riool regelmatig verstopt raakt, kan hij het probleem identificeren door de binnenkant van je leidingen te inspecteren met behulp van een camera ... een voorzorgsmaatregel die veel problemen kan voorkomen (lekkages, infiltraties enzovoort). Als hij een ontstoppingsmiddel gebruikt, is dat een speciaal samengestelde samenstelling die voldoet aan de milieunormen.Om de prijs te kennen van de interventie van een loodgieter om je leidingen te ontstoppen, vraag je best om gecontacteerd te worden door een specialist. Vul hiervoor alle velden in om de omvang van de werkzaamheden te verduidelijken.    "
    },
    {
        "id": "service-moistureOffCanvasBulletPointSubText",
        "FR": "Il n’y a rien de plus désagréable dans une habitation que l’apparition de taches d’humidité ou de moisissure sur les murs. D’autant plus que ces dégâts peuvent rapidement s’aggraver et même avoir un impact sur notre santé. Bref, dès que ces traces apparaissent, consultez sans attendre un spécialiste. Il devra d’abord explorer votre réseau de canalisations (éventuellement au moyen d’une caméra). S’il identifie l’origine du problème au niveau de la tuyauterie, faites effectuer la réparation de la conduite concernée. S’il s’agit d’humidité ascensionnelle (par le sol), il faudra alors faire traiter vos murs et sol en vue de procéder le plus rapidement possible à l’assèchement des surfaces. Pour connaître le montant global d’une telle prestation, demandez à être recontacté par un professionnel. Pour ce faire, complétez tous les champs destinés à préciser l’étendue des travaux à réaliser. ",
        "NL": "Er is niets vervelender in een woning dan het verschijnen van vochtvlekken of schimmel op de muren. Vooral omdat deze schade snel kan verergeren en zelfs invloed op onze gezondheid kan hebben. Raadpleeg dus direct een specialist zodra deze sporen verschijnen. Om te beginnen zal de loodgieter je leidingnetwerk onderzoeken (eventueel met behulp van een camera). Als hij de oorzaak van het probleem bij de leidingen identificeert, laat dan de betreffende leiding repareren. Als het gaat om opstijgend vocht (vanuit de grond), zal de vochtexpert je muren en vloer moeten behandelen om het droogproces van de oppervlakken te versnellen. Om de totale kosten van een dergelijke dienst te kennen, vraag je best om gecontacteerd te worden door een expert. Vul hiervoor alle velden in om de omvang van de werkzaamheden te verduidelijken."
    },
    {
        "id": "service-leakOffCanvasBulletPointSubText",
        "FR": "Les plombiers proposés par AXA Homecare ont été sélectionnés pour leur expertise et leur travail soigné. De plus, vous avez la garantie qu’ils n’utilisent que du matériel professionnel et conforme aux normes en vigueur. Que vous disposiez d’une installation classique (avec plusieurs robinets reliés à un même circuit) ou d’un réseau partagé (avec tuyaux indépendants partant du collecteur central de la chaudière). Ils calculent leurs tarifs en fonction du type de travaux à réaliser. Pour limiter les frais de déplacement, AXA Homecare a répertorié les hommes de métier les plus fiables de votre région. Vous souhaitez connaître le montant précis de la prestation dont vous avez besoin ? Demandez à être recontacté par un professionnel. Complétez déjà tous les champs destinés à préciser l’étendue des travaux à réaliser et vous aurez, dans les 48 heures, des nouvelles du professionnel le plus indiqué pour répondre à votre demande. ",
        "NL": "De loodgieters die AXA Homecare aanbiedt, zijn geselecteerd vanwege hun expertise en vakmanschap. Bovendien kan je erop vertrouwen dat zij alleen gebruikmaken van professioneel materiaal dat aan de geldende normen voldoet, of je nu beschikt over een traditioneel leidingnetwerk (met meerdere kranen die op één circuit zijn aangesloten) of een gescheiden netwerk (met afzonderlijke leidingen vanuit de centrale verzamelaar van de ketel). Zij berekenen hun tarieven op basis van het type uit te voeren werken. Om de verplaatsingskosten te beperken, heeft AXA Homecare de meest betrouwbare vakmensen in jouw regio geselecteerd. Wil je de precieze kosten van de gewenste dienst kennen? Vraag om gecontacteerd te worden door een specialist. Vul alvast alle velden in om de omvang van de uit te voeren werkzaamheden te verduidelijken, en binnen 48 uur ontvang je nieuws van de meest geschikte specialist om aan je verzoek te voldoen."
    },
    {
        "id": "service-parquetOffCanvasBulletPointSubText",
        "FR": "",
        "NL": ""
    },
    {
        "id": "service-floorTilesOffCanvasBulletPointSubText",
        "FR": "Pierre bleue ou autre pierre naturelle, grès, céramique ou faïence, marbre ou granit, matériaux composites, béton ciré... La palette de possibilités est infinie lorsqu’il s’agit de choisir votre revêtement de sol ou mural. Il est donc souvent très utile de bénéficier des conseils avisés d’un professionnel car toutes les matières ne se prêtent pas à tous les usages. De plus, les conditions ne sont pas identiques dans les espaces intérieurs ou en extérieur, au sol ou au mur. Et - surtout - une fois posés, il n’est pas si simple d’ôter ces carrelages si le résultat final ne vous plaît pas. Les carreleurs et autres spécialistes du revêtement proposés par AXA Homecare sont en mesure de vous guider vers la meilleure option en fonction de la configuration de votre habitation et de vos goûts. Ils pourront ensuite s’atteler sereinement à la préparation des surfaces à carreler : nettoyage, réparation partielle ou ragréage complet en cas de surface très abîmée (après avoir éventuellement dû couler une chape), lissage, couche d’accrochage, etc. Avant de finalement poser votre carrelage et procéder à la finition (joints, plinthes, ...). Certains particuliers sont eux-mêmes bien informés et préfèrent donc aller acheter eux-mêmes leurs carrelages. Ils font dès lors uniquement appel à un carreleur pour la pose. Mais il est possible de confier également l’achat des matériaux au spécialiste qui se chargera de la prestation. Certains des hommes de métier du réseau AXA Homecare peuvent même vous proposer des catalogues pour vous aider à sélectionner votre carrelage. Comme vous l'avez compris, le prix des travaux à réaliser dépend de l’état de la surface à carreler et de l’étendue des prestations qui devront être effectuées. C’est pourquoi AXA Homecare vous conseille de demander - avant le démarrage des travaux - un devis au spécialiste que nous sélectionnons pour vous. Sachez cependant que nous vous proposons uniquement les entreprises de votre région qui offrent un bon rapport qualité-prix.",
        "NL": "Blauwe hardsteen of ander natuursteen, zandsteen, keramiek of faience, marmer of graniet, composietmaterialen, gepolijst beton... De mogelijkheden zijn eindeloos als het gaat om het kiezen van jouw vloer- of wandbekleding. Daarom is het vaak zeer nuttig om deskundig advies in te winnen van een specialist, omdat niet elk materiaal geschikt is voor alle toepassingen. Bovendien zijn de omstandigheden niet hetzelfde in binnen- of buitenruimtes, op de vloer of aan de muur. En - nog belangrijker - eenmaal geplaatst, is het niet zo eenvoudig om deze tegels te verwijderen als het eindresultaat niet bevalt. De tegelzetters en andere specialisten in bekleding die AXA Homecare aanbeveelt, kunnen je begeleiden bij de beste optie op basis van de indeling van jouw woning en jouw voorkeuren. Vervolgens kunnen ze rustig aan de slag met de voorbereiding van de te betegelen oppervlakken: reiniging, gedeeltelijke reparatie of complete egalisatie in het geval van ernstig beschadigde oppervlakken (nadat mogelijk een dekvloer is gestort), egaliseren, hechtlaag, enz. Om tenslotte jouw tegels te plaatsen en af te werken (voegen, plinten, ...). Sommige particulieren zijn goed geïnformeerd en gaan liever zelf hun tegels kopen. Ze schakelen dan alleen een tegelzetter in voor het plaatsen. Maar het is ook mogelijk om de aankoop van materialen toe te vertrouwen aan de specialist die de opdracht uitvoert. Sommige van de vakmensen in het AXA Homecare-netwerk kunnen je zelfs catalogi aanbieden om je te helpen bij het kiezen van je tegels. Zoals je hebt begrepen, hangt de prijs van de uit te voeren werken af van de staat van het te betegelen oppervlak en de omvang van de werkzaamheden die moeten worden uitgevoerd. Daarom raadt AXA Homecare je aan om voor aanvang van de werkzaamheden een offerte aan te vragen bij de specialist die we voor jou selecteren. Houd er echter rekening mee dat we alleen bedrijven in jouw regio aanbieden die een goede prijs-kwaliteitverhouding bieden."
    },
    {
        "id": "service-PaintingAndFurnishingOffCanvasBulletPointSubText",
        "FR": "Vous allez bientôt déménager ou il est temps de rafraîchir le logement que vous occupez depuis belle lurette ? Ou alors c’est à votre coin terrasse ou votre véranda que vous voulez donner un petit coup d’éclat ? À moins que vous ayez été confronté à un dégât des eaux ou autre accident de ce type... Autant de circonstances où vous aurez probablement besoin de faire appel à un peintre et/ou même un décorateur. Enduisage, pose de papier-peint ou de fibre de verre, peinture intérieure ou extérieure* ? Choix de produits traditionnels, naturels ou plutôt écologiques et durables ? Le tout conformément aux réglementations et aux labels en vigueur... À chaque étape de votre projet de (ré)aménagement, vous serez amené à prendre des renseignements et à faire des choix. Si nécessaire, n’hésitez pas à demander conseil aux peintres et décorateurs du réseau AXA Homecare. Nous les avons sélectionnés en fonction de leur expertise reconnue et de la garantie qu’ils nous offrent de pratiquer des prix conformes au marché. ",
        "NL": "Ga je binnenkort verhuizen of is het tijd om je lang bewoonde woning op te frissen? Of wil je je terras of veranda wat nieuw leven inblazen? Misschien heb je te maken gehad met waterschade of een ander soort ongeluk... Dit zijn allemaal situaties waarin je waarschijnlijk een schilder en/of decorateur nodig zult hebben. Pleisterwerk, behangen met papier of glasvezel, binnen- of buitenschilderwerk*? Keuze tussen traditionele, natuurlijke of eerder ecologische en duurzame producten? Dit allemaal in overeenstemming met de geldende voorschriften en labels... Bij elke stap van jouw (her)inrichtingsproject zul je informatie moeten inwinnen en keuzes moeten maken. Indien nodig, aarzel niet om advies te vragen aan de schilders en decorateurs in het AXA Homecare-netwerk. We hebben ze geselecteerd op basis van hun erkende expertise en de garantie die ze ons bieden dat ze prijzen hanteren die marktconform zijn."
    },
    {
        "id": "service-electricalInstallationOffCanvasBulletPointSubText",
        "FR": "Les électriciens sélectionnés par AXA Homecare vous garantissent des prestations de qualité et conformes aux normes en vigueur. De plus, ils n’utilisent que du matériel professionnel, gage de votre sécurité. Lorsque vous faites appel à un électricien, vous allez payer sa main-d’œuvre (taux horaire ou au m2 si construction/rénovation), les équipements et matériaux utilisés, ses frais de déplacement, la TVA (21% pour les habitations neuves et 6% pour les appareillages encastrés ou dans les bâtiments de +10 ans). Pour connaître le montant de la prestation dont vous souhaitez bénéficier, demandez à être recontacté par un professionnel. Pour ce faire, complétez tous les champs destinés à préciser l’étendue des travaux à réaliser. ",
        "NL": "De door AXA Homecare geselecteerde elektriciens garanderen kwalitatieve diensten die voldoen aan de geldende normen. Bovendien maken ze alleen gebruik van professioneel materiaal, wat je veiligheid waarborgt. Wanneer je een beroep doet op een elektricien, betaal je voor arbeidskosten (uurloon of per vierkante meter bij nieuwbouw/renovatie), gebruikte apparatuur en materialen, verplaatsingskosten en BTW (21% voor nieuwe woningen en 6% voor inbouwapparatuur of in gebouwen ouder dan 10 jaar). Om het bedrag te kennen van de dienst waar je gebruik van wenst te maken, vraag je best om door een specialist gecontacteerd te worden. Vul hiervoor alle velden in om de omvang van de uit te voeren werkzaamheden te verduidelijken."
    },
    {
        "id": "service-homeAutomationOffCanvasBulletPointSubText",
        "FR": "Les techniciens en électricité et domotique sélectionnés par AXA Homecare sont qualifiés pour vous garantir des prestations de qualité, conformes aux normes en vigueur. De plus, ils n’utilisent que du matériel professionnel, gage de votre sécurité. L'électricien spécialisé en domotique élabore une offre de prix en fonction de vos besoins et de la technologie souhaitée. De plus, il peut concevoir l’installation domotique complète de votre habitation ou envisager de travailler par phases afin de vous permettre d’évoluer pas à pas vers une installation plus complète. Contrairement aux idées reçues, même une maison ancienne peut en être équipée, par exemple pour vous permettre de réaliser des économies de chauffage (thermostat intelligent, vannes thermostatiques connectées, etc.). Vu l’engouement pour ces technologies, le prix des différents appareils est de plus en plus abordable.        Une fois encore, faites appel à des professionnels de la domotique non seulement pour bénéficier d’une installation de qualité, mais aussi et surtout pour vous éviter les risques de surchauffe et garantir votre sécurité.Le choix des emplacements les plus judicieux, la prise en compte des coûts énergétiques, etc achèveront de vous convaincre.Pour avoir une idée du montant de la prestation que vous souhaitez, demandez à être recontacté par un professionnel.Pour ce faire, complétez tous les champs destinés à préciser l’étendue des travaux à réaliser.",
        "NL": "De door AXA Homecare geselecteerde elektriciteits- en domoticatechnici zijn gekwalificeerd om kwalitatieve diensten te garanderen die voldoen aan de geldende normen. Bovendien maken ze alleen gebruik van professioneel materiaal, wat je veiligheid waarborgt. De domotica-specialist stelt op basis van je behoeften en de gewenste technologie een prijsvoorstel op. Bovendien kan hij de complete domotica-installatie van je woning ontwerpen of werken in fases overwegen, zodat je geleidelijk kunt evolueren naar een uitgebreidere installatie. In tegenstelling tot wat vaak gedacht wordt, kan zelfs een oud huis ermee worden uitgerust, bijvoorbeeld om energiebesparingen te realiseren (slimme thermostaat, verbonden thermostatische radiatorkranen, enz.). Gezien de populariteit van deze technologieën wordt de prijs van verschillende apparaten steeds betaalbaarder. Roep opnieuw de hulp in van domotica-experts, niet alleen om van een kwalitatieve installatie te genieten, maar vooral om risico's op oververhitting te voorkomen en je veiligheid te waarborgen. De keuze van de meest geschikte locaties, rekening houdend met de energiekosten, enz., zal je overtuigen. Om een idee te krijgen van de kostprijs voor de gewenste dienst, vraag je best om door een specialist gecontacteerd te worden. Vul hiervoor alle velden in om de omvang van de uit te voeren werkzaamheden te verduidelijken."
    },
    {
        "id": "service-alarmSystemOffCanvasBulletPointSubText",
        "FR": "Les spécialistes de la sécurité sélectionnés par AXA Homecare sont tous agréés ; ils vous garantissent des prestations de qualité et conformes aux réglementations bien spécifiques en vigueur dans ce domaine (nombreuses normes IEC et NBN EN IEC, norme NBN S21-100, note T015-2, règles RGPD et autres règles relatives aux caméras de surveillance, etc.). De plus, ils n’utilisent que des équipements certifiés. Par ailleurs, le choix de solutions proposées pour sécuriser votre logement est extrêmement vaste. Pour vous aider à mieux cerner le type d’installation qui vous conviendra le mieux tout en respectant votre budget, n’hésitez pas à négocier ouvertement votre devis avec le spécialiste. Pour connaître le montant de la prestation dont vous souhaitez bénéficier, demandez à être recontacté par un professionnel. Pour ce faire, complétez tous les champs destinés à préciser l’étendue des travaux à réaliser. ",
        "NL": "De door AXA Homecare geselecteerde beveiligingsspecialisten zijn allemaal erkend. Zij garanderen kwalitatieve diensten die voldoen aan de specifieke regelgevingen die in dit vakgebied gelden (vele IEC- en NBN EN IEC-normen, NBN S21-100-norm, nota T015-2, GDPR-regels en andere regels met betrekking tot bewakingscamera's, enz.). Bovendien maken ze alleen gebruik van gecertificeerde apparatuur. Er is een breed scala aan oplossingen beschikbaar om je woning te beveiligen. Om je te helpen het type installatie te bepalen dat het beste bij je past en tegelijkertijd je budget te respecteren, aarzel niet om de offerte te bespreken. Om een idee te krijgen van de kostprijs voor de gewenste dienst, vraag je best om door een specialist gecontacteerd te worden. Vul hiervoor alle velden in om de omvang van de uit te voeren werkzaamheden te verduidelijken. "
    },
    {
        "id": "service-cleaningGuttersOffCanvasBulletPointSubText",
        "FR": "Il vous est conseillé de (faire) nettoyer tous les ans vos gouttières et corniches. Saletés, feuilles mortes et autres végétaux s’y accumulent en effet, ce qui peut bloquer peu à peu l’écoulement des eaux de pluie. Ou – pire – occasionner des débordements qui endommageront vos murs, votre façade et votre toiture. Il convient donc aussi d’installer des protections (grilles) et/ou de remplacer certaines parties du circuit lorsqu’elles sont abîmées. Ce genre de prestations se facturent généralement au mètre, pour un prix qui varie suivant le nombre de tâches à effectuer. N’hésitez donc pas à demander - avant le démarrage des travaux - un devis au spécialiste que nous sélectionnons pour vous. Sachez cependant qu’AXA Homecare vous propose toujours des entreprises de votre région qui offrent un bon rapport qualité-prix.",
        "NL": "Het wordt aangeraden om jaarlijks je dakgoten en daklijsten te laten reinigen. Vuil, bladeren en andere vegetatie hopen zich namelijk op, wat langzaamaan de afvoer van regenwater kan blokkeren. Of – erger nog – overstromingen kan veroorzaken die je muren, gevel en dak beschadigen. Het is daarom ook raadzaam om bescherming (roosters) te installeren en/of bepaalde delen van het systeem te vervangen als ze beschadigd zijn. Dergelijke diensten worden meestal per meter in rekening gebracht, tegen een prijs die varieert op basis van het aantal taken dat moet worden uitgevoerd. Aarzel dus niet om vóór aanvang van de werkzaamheden een offerte aan te vragen bij de specialist die we voor je geselecteerd hebben. Houd er echter rekening mee dat AXA Homecare altijd betrouwbare vakmensen in je regio aanbeveelt die een goede prijs-kwaliteitverhouding bieden."
    },
    {
        "id": "service-chimneysOffCanvasBulletPointSubText",
        "FR": "Comme un conduit d’évacuation encrassé peut s’obstruer et, de ce fait, occasionner un incendie, le ramonage (bis)annuel de votre cheminée est obligatoire. Suivant la région où se situe votre habitation (Région de Bruxelles-Capitale, Flandre ou Wallonie), consultez le site des instances officielles pour connaître les conditions auxquelles votre situation correspond. C’est à ce point important que vous devez même - le cas échéant - pouvoir présenter l’attestation délivrée par un ramoneur agréé avant que ces instances effectuent le contrôle PEB (certificat de la performance énergétique des bâtiments). De même, en cas de panne ou autre problème, un chauffagiste pourrait refuser d’intervenir si vous n’avez pas fait ramoner votre cheminée. Sans parler des risques d’intoxication au monoxyde de carbone auxquels vous vous exposez ! Bref, nous n’avons qu’un conseil à vous donner : ne jouez pas avec votre sécurité. Évidemment, le budget à prévoir sera fonction de l’état de votre cheminée et des différentes prestations qui devront être effectuées. Peu importe le degré de complexité de l’intervention dont vous avez besoin : AXA Homecare vous propose toujours des entreprises de votre région qui offrent un bon rapport qualité-prix et dont l’expertise est unanimement reconnue.",
        "NL": "Omdat een verstopt rookkanaal tot een brand kan leiden, is het (2-)jaarlijkse vegen van je schoorsteen verplicht. Afhankelijk van de regio waarin je woont (Brussels Hoofdstedelijk Gewest, Vlaanderen of Wallonië), raadpleeg je de website van de officiële instanties om de voorwaarden te kennen die op jouw situatie van toepassing zijn. Dit is zo belangrijk dat je zelfs – indien nodig – een attest van een erkende schoorsteenveger moet kunnen voorleggen voordat deze instanties de EPC-controle (energieprestatiecertificaat van gebouwen) uitvoeren. Ook kan een verwarmingsmonteur bij een defect of ander probleem weigeren tussen te komen als je je schouwen niet hebt laten vegen. Vergeet ook niet de risico's op koolmonoxidevergiftiging waaraan je wordt blootgesteld! Kortom, speel niet met je veiligheid. Natuurlijk hangt het te verwachten budget af van de staat van je schoorsteen en de verschillende diensten die moeten worden uitgevoerd. Ongeacht de complexiteit van de interventie die je nodig hebt, beveelt AXA Homecare altijd betrouwbare vakmensen in je regio aan die een goede prijs-kwaliteitverhouding bieden en van wie de expertise algemeen erkend is."
    },
    {
        "id": "service-paintingFacadeOffCanvasBulletPointSubText",
        "FR": "Votre façade fait grise mine ? Il est grand temps de lui donner un petit coup de fraîcheur ? Ou alors vous venez d’emménager dans une nouvelle habitation et il vous faut encore procéder aux finitions, notamment aux peintures extérieures ? Que vos murs soient en briques, en pierre, en béton ou en bois, déjà enduits ou non, couverts ou non de crépi minéral ou à base de résine, les peintres de façades du réseau AXA Homecare pourront répondre à votre demande. En fonction du support, ils vous recommanderont la meilleure solution pour assurer une protection optimale de vos murs sans sacrifier à l’esthétique.Étant donné la large palette de prestations possibles, pour avoir une idée du budget à prévoir, demandez un devis à l’homme de métier qui prendra contact avec vous.Quoi qu’il en soit, sachez qu’AXA Homecare a choisi ses partenaires en fonction de leur expertise reconnue et de la garantie qu’ils vous offrent de pratiquer des prix conformes au marché.",
        "NL": "Ziet je gevel er wat dof uit? Is het hoog tijd om hem op te frissen? Of ben je net verhuisd naar een nieuwe woning en moeten de laatste afwerkingen, waaronder het buitenschilderwerk, nog worden gedaan? Of je muren nu van baksteen, steen, beton of hout zijn, al dan niet gestuukt, bedekt met een minerale pleister of een harspleister, de gevelschilders uit het AXA Homecare-netwerk kunnen aan je wensen voldoen. Afhankelijk van het oppervlak zullen ze je de beste oplossing aanraden om je muren optimaal te beschermen zonder afbreuk te doen aan esthetiek. Vanwege de diverse mogelijkheden die er zijn, vraag je het best een offerte aan bij de vakman die contact met je zal opnemen. Hoe dan ook, onthoud dat AXA Homecare zijn partners heeft geselecteerd op basis van hun erkende expertise en de garantie dat ze marktconforme prijzen hanteren."
    },
    {
        "id": "service-pruningOffCanvasBulletPointSubText",
        "FR": "Vous avez des arbres ou des massifs dont le branchage déborde sur l’espace public ou sur la propriété de vos voisins ? Il est alors grand temps de procéder à leur élagage ! D’autant plus que - contrairement à la taille qui vise uniquement à « sculpter » un massif pour lui donner une allure bien précise (haie, ifs décoratifs, etc) -, cette étape de l’élagage est nécessaire pour préserver leur bonne santé et leur robustesse... et même leur éviter la propagation de certaines maladies. Il est fortement conseillé de faire appel à un professionnel pour ce type de prestation (pour respecter les règles de sécurité, mais aussi pour ne pas endommager vos arbres). La meilleure saison pour pratiquer l’élagage est l’automne, même si vous pouvez le faire aussi en d’autres saisons (excepté au printemps, moment de la montée de la sève). Quant aux tarifs en vigueur, ils sont fonction du type et du nombre d’arbres, de leurs dimensions, du type d’élagage souhaité, etc. Pour avoir une idée plus précise de ce que cette prestation va vous coûter, demandez un devis à l’élagueur qui prendra contact avec vous pour fixer un rendez-vous. Notez aussi qu’en cas d’intempéries ou de conditions mettant sa sécurité en danger (troncs glissants, etc), un vrai professionnel vous proposera une date ultérieure, cela fait partie des risques liés à son métier.",
        "NL": "Heb je bomen of struiken waarvan de takken overhangen naar de openbare ruimte of het eigendom van je buren? Dan is het hoog tijd om ze te snoeien! Vooral omdat – in tegenstelling tot trimmen, dat uitsluitend gericht is op het \"vormgeven\" van een struik om het een specifieke uitstraling te geven (haag, decoratieve taxussen, …) – dit snoeiwerk nodig is om hun gezondheid en kracht te behouden ... en zelfs de verspreiding van bepaalde ziekten te voorkomen. Het is sterk aanbevolen om voor dit soort werk een specialist in te schakelen (om veiligheidsvoorschriften te volgen en om je bomen niet te beschadigen). Het beste seizoen om te snoeien is de herfst, hoewel je het ook in andere seizoenen kan doen (behalve in het voorjaar, wanneer de sapstroom op gang komt). De geldende tarieven zijn afhankelijk van het type en het aantal bomen, hun afmetingen, het gewenste type snoei enzovoort. Voor een nauwkeuriger idee van de kosten van deze dienst vraag je een offerte aan bij de boomsnoeier die contact met je zal opnemen om een afspraak te maken. Houd er ook rekening mee dat bij slecht weer of omstandigheden die zijn veiligheid in gevaar brengen (gladde stammen, …), een echte specialist een latere datum zal voorstellen. Dat zijn de risico's van zijn beroep."
    },
    {
        "id": "newProjectExpertCheckPostCodeErrorHeader",
        "FR": "Mauvais code postal",
        "NL": "Foute postcode"
    },
    {
        "id": "newProjectExpertCheckPostCodeErrorText",
        "FR": "Vérifiez le code postal et assurez-vous qu'il se compose de quattre chiffres",
        "NL": "Controleer de postcode en zorg ervoor dat deze bestaat uit vier cijfers"
    },
    {
        "id": "footPrivacyPolicy",
        "FR": "Privacy policy",
        "NL": "Privacy policy"
    },
    {
        "id": "footCookiePolicy",
        "FR": "Cookie Policy",
        "NL": "Cookie Policy"
    },
    {
        "id": "footRightsReserved",
        "FR": "All rights reserved",
        "NL": "All rights reserved"
    },
    {
        "id": "service-plumBoilerBulletPoint1",
        "FR": "Analyse de votre habitation et de votre usage",
        "NL": "Analyse van je woning en je gebruik"
    },
    {
        "id": "service-plumBoilerBulletPoint2",
        "FR": "Proposition du dispositif le plus adapté à votre situation",
        "NL": "Voorstel van het meest geschikte systeem voor jouw situatie"
    },
    {
        "id": "service-plumBoilerBulletPoint3",
        "FR": "Installation conforme aux normes en vigueur",
        "NL": "Installatie volgens geldende normen"
    },
    {
        "id": "service-plumBoilerBulletPoint4",
        "FR": "Remplacement de pièces défectueuses ou usées",
        "NL": "Vervanging van defecte of versleten onderdelen "
    },
    {
        "id": "service-plumBoilerBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-plumCvKetelBulletPoint1",
        "FR": "Analyse de votre habitation",
        "NL": "Analyse van je woning "
    },
    {
        "id": "service-plumCvKetelBulletPoint2",
        "FR": "Proposition de la technologie la plus adaptée à votre situation",
        "NL": "Voorstel van de meest geschikte technologie voor jouw situatie"
    },
    {
        "id": "service-plumCvKetelBulletPoint3",
        "FR": "Information sur les aides financières éventuellement disponibles (primes, etc)",
        "NL": "Informatie over eventueel beschikbare financiële hulp (premies, …)"
    },
    {
        "id": "service-plumCvKetelBulletPoint4",
        "FR": "Remplacement de pièces défectueuses ou usées",
        "NL": "Vervanging van defecte of versleten onderdelen"
    },
    {
        "id": "service-plumCvKetelBulletPoint5",
        "FR": "...",
        "NL": "..."
    },
    {
        "id": "service-plumBoiler",
        "FR": "Chauffe-eau",
        "NL": "Boiler"
    },
    {
        "id": "service-plumCvKetel",
        "FR": "Chaudiere",
        "NL": "Centrale verwarming"
    },
    {
        "id": "service-plumBoilerOffCanvasBulletPointSubText",
        "FR": "Si vous souhaitez faire installer un nouveau boiler ou chauffe-eau, le plombier-chauffagiste recommandé par AXA Homecare vous présentera les différents systèmes disponibles sur le marché pour la production d’eau chaude sanitaire. Modèle à accumulation avec réserve d’eau chaude disponible en permanence (boiler) ou chauffe-eau instantané, appareil au gaz, électrique, solaire ou thermodynamique... il vous aidera à faire votre choix en fonction de vos besoins et des contraintes de votre logement. Si c’est une réparation ou un dépannage dont vous avez besoin, le professionnel proposé vous interrogera sur le dispositif installé dans votre logement afin de prévoir tout ce qu’il faut pour vous dépanner efficacement et dans les meilleurs délais (sous réserve de disponibilité des pièces de rechange éventuellement nécessaires). Vous l’aurez compris : il existe une grande diversité de modèles et leur prix varie donc en fonction des marques et de leur degré de sophistication.  Quant aux tarifs de l’installateur, ses prestations sont bien sûr différentes suivant le type de technologie que vous choisirez. Mais sachez cependant qu’AXA Homecare recherche pour vous les prestataires de votre région qui offrent un très bon rapport qualité-prix.",
        "NL": "Als je een nieuwe boiler of warmwaterketel wilt laten installeren, zal de door AXA Homecare aanbevolen loodgieter-verwarmingsspecialist je de verschillende beschikbare systemen op de markt presenteren voor de productie van warm sanitair water. Een model met warmteopslag met permanent beschikbaar warm water (boiler) of een instant warmwaterketel, een gas-, elektrisch-, zonne- of thermodynamisch apparaat... hij zal je helpen bij het maken van de juiste keuze op basis van jouw behoeften en de specificaties van jouw woning. Als je reparatie of een herstelling nodig hebt, zal de voorgestelde specialist je vragen naar het apparaat dat in jouw huis is geïnstalleerd om alle benodigde materialen voor een efficiënte en tijdige reparatie te plannen (afhankelijk van beschikbaarheid van eventueel vereiste vervangingsonderdelen). Zoals je hebt begrepen, zijn er veel modellen en de prijzen variëren dus afhankelijk van de merken en de mate van geavanceerdheid. Wat de tarieven van de installateur betreft, deze verschillen uiteraard per gekozen technologie. Maar weet dat AXA Homecare bedrijven met de beste prijs-kwaliteitverhouding voor jou in jouw regio heeft geselecteerd."
    },
    {
        "id": "service-plumCvKetelOffCanvasBulletPointSubText",
        "FR": "Vous envisagez de faire installer une nouvelle chaudière dans votre habitation ? Les chauffagistes recommandés par AXA Homecare sont en mesure de vous présenter les différentes solutions possibles en fonction de votre situation (lieu, taille du logement, usage, etc.). Ils pourront également vous conseiller afin de vous aider à faire votre choix parmi les différents modèles disponibles sur le marché et ce, en fonction de vos critères prix, praticité, performance, sécurité, impact écologique.... C’est plutôt pour une réparation que vous recherchez un spécialiste ? Il arrive qu’un entretien permette déjà de résoudre un problème de chaudière. Si ce n’est pas le cas, il s’agit le plus souvent de remplacer une pièce défectueuse ou de réparer une fuite. Quoi qu’il en soit, faites réaliser ces interventions par un professionnel qui vous évitera bien des déboires.",
        "NL": "Overweeg je een nieuwe verwarmingsketel in je huis te laten installeren? De verwarmingstechnici die door AXA Homecare worden aanbevolen, kunnen je de mogelijke oplossingen presenteren op basis van jouw situatie (locatie, grootte van de woning, gebruik, enz.). Ze kunnen je ook adviseren bij het kiezen uit de verschillende modellen op de markt, rekening houdend met jouw criteria zoals prijs, gebruiksgemak, prestaties, veiligheid, milieu-impact...Ben je eerder op zoek naar een reparateur? Soms kan een onderhoudsbeurt al een probleem met de ketel oplossen. Als dat niet het geval is, gaat het meestal om het vervangen van een defect onderdeel of het repareren van een lek. In ieder geval is het raadzaam om deze interventies door een specialist te laten uitvoeren om problemen te voorkomen."
    },
    {
        "id": "newProjectConfirmationSubHeader",
        "FR": "pour votre demande",
        "NL": "voor uw aanvraag"
    },
    {
        "id": "btnOpenFileDialogMobile",
        "FR": "PRENEZ UNE PHOTO",
        "NL": "NEEM EEN FOTO"
    },
    {
        "id": "newProjectCustomerInfoErrorCustomerAddress",
        "FR": "s'il-vous-plaît entrez une adresse valide",
        "NL": "Gelieve een geldig adres in te vullen"
    },
    {
        "id": "newProjectCustomerInfoErrorDivCustomerAddress",
        "FR": "",
        "NL": ""
    },
    {
        "id": "buttonMoreInfo",
        "FR": "Plus d’infos",
        "NL": "Meer info"
    },
    {
        "id": "footCookieSettings",
        "FR": "Préférences Cookies",
        "NL": "Cookies Voorkeuren"
    },
    {
        "id": "newProjectCustomerInfoErrorDivCustomerIsAxaCustomer",
        "FR": "Veuillez indiquer si vous êtes client chez AXA.",
        "NL": "Gelieve aan te geven of je klant bent bij AXA."
    },
    {
        "id": "service-plumBoilerCardTitle",
        "FR": "Chauffe-eau",
        "NL": "Boiler"
    },
    {
        "id": "service-plumCvKetelCardTitle",
        "FR": "Chaudière chauffage central",
        "NL": "Centrale verwarmingsketel"
    },
    {
        "id": "service-PaintingAndFurnishingCardTitle",
        "FR": "Peinture & decoration",
        "NL": "Schilderen & Inrichting"
    },
    {
        "id": "newProjectBackToHome",
        "FR": "Retour à la page d'accueil",
        "NL": "Terug naar de startpagina"
    },
    {
        "id": "shortNotice",
        "FR": "INTER PARTNER ASSISTANCE collecte et traite vos données personnelles afin de gérer votre demande d'assistance dans le cadre de l'exécution de votre contrat d'assurance. En outre, INTER PARTNER ASSISTANCE peut être amenée à traiter des données afin d'améliorer la qualité de ses services, de gérer d'éventuelles réclamations, de lutter contre d'éventuelles fraudes ou d'établir des statistiques sur la base de son intérêt légitime.  Toutes les informations demandées sont obligatoires afin de vous fournir le service approprié. Pour plus d\'informations, veuillez consulter notre ",
        "NL": "INTER PARTNER ASSISTANCE verzamelt en verwerkt uw persoonsgegevens om uw verzoek om bijstand in het kader van de uitvoering van uw verzekeringsovereenkomst te behandelen. Daarnaast kan INTER PARTNER ASSISTANCE gegevens verwerken om de kwaliteit van haar dienstverlening te verbeteren, eventuele klachten te behandelen, fraude te bestrijden of statistieken op te stellen op basis van haar gerechtvaardigd belang. Alle gevraagde informatie is verplicht om u de juiste dienst te kunnen leveren. Voor meer informatie kunt u ons "
    },
    {
        "id": "shortNoticeLinkEnding",
        "FR": "politique de confidentialité.",
        "NL": "privacybeleid raadplegen."
    }
]


export default translate;